/* ============================================================================
   Reway theme — global interactions
   Mobile nav · cart drawer (AJAX + Section Rendering API) · predictive search ·
   quick-shop · add-to-cart. Vanilla JS, no dependencies.
   ========================================================================== */
(function () {
  'use strict';
  var theme = window.theme || {};
  var routes = theme.routes || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* product.js is render-critical only on a PDP. Other templates load it on the
     first quick-shop request, in parallel with the section fragment. */
  var productRuntimePromise = null;
  function loadProductRuntime() {
    if (window.customElements && customElements.get('product-form')) return Promise.resolve();
    if (productRuntimePromise) return productRuntimePromise;
    var src = theme.assets && theme.assets.product;
    if (!src) return Promise.reject(new Error('Product runtime URL unavailable'));
    productRuntimePromise = new Promise(function (resolve, reject) {
      var script = document.querySelector('script[data-rw-product-runtime]');
      var settled = false;
      var timeoutId = setTimeout(function () { failed('Product runtime timed out'); }, 8000);
      function discard() { if (script && script.parentNode) script.parentNode.removeChild(script); }
      function ready() {
        if (settled) return;
        if (window.customElements && customElements.get('product-form')) {
          settled = true; clearTimeout(timeoutId); resolve();
        } else failed('Product runtime did not register product-form');
      }
      function failed(message) {
        if (settled) return;
        settled = true; clearTimeout(timeoutId); discard();
        reject(new Error(message || 'Product runtime failed to load'));
      }
      if (script) {
        if (window.customElements && customElements.get('product-form')) { settled = true; clearTimeout(timeoutId); resolve(); return; }
        script.addEventListener('load', ready, { once: true });
        script.addEventListener('error', function () { failed(); }, { once: true });
        return;
      }
      script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.setAttribute('data-rw-product-runtime', '');
      script.addEventListener('load', ready, { once: true });
      script.addEventListener('error', function () { failed(); }, { once: true });
      document.head.appendChild(script);
    });
    productRuntimePromise = productRuntimePromise.catch(function (error) {
      productRuntimePromise = null;
      throw error;
    });
    return productRuntimePromise;
  }

  function money(cents) {
    try {
      return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: theme.settings.currency || 'EUR' }).format(cents / 100);
    } catch (e) { return '€' + (cents / 100).toFixed(2); }
  }

  /* ----------------------------------------------------- body scroll lock */
  var lockCount = 0;
  function lockScroll(on) {
    lockCount = Math.max(0, lockCount + (on ? 1 : -1));
    document.body.style.overflow = lockCount > 0 ? 'hidden' : '';
  }
  window.rwLockScroll = lockScroll; /* W6-9 gate (FQE): menu-drawer en zoekoverlay (header.liquid) delen dezelfde teller — cart-drawer vanuit het menu hield anders geen lock */

  /* ------------------------------------------ dialog-helper + live-region (W6-5, IxD-gate) */
  /* Eén gedrag voor drawer en quick-shop: focus het paneel in, Tab/Shift+Tab blijven binnen,
     de rest van de pagina wordt inert, en bij elke sluitroute keert de focus terug naar de trigger. */
  var rwDialogs = [];
  function rwFocusables(root) {
    return $$('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])', root)
      .filter(function (el) { return el.offsetParent !== null; });
  }
  function rwDialogOpen(root, opts) {
    if (!root) return;
    opts = opts || {};
    var rec = { root: root, trigger: opts.trigger || document.activeElement, inerted: [], reinert: [] };
    /* W7-2 r3 (Mobile B1): een dialoog die boven een andere dialoog opent (quick-shop uit de zoekoverlay)
       was zelf al inert gezet door de onderliggende dialoog — maak de eigen keten vrij, herstel bij sluiten. */
    var up = root;
    while (up && up !== document.documentElement) {
      if (up.hasAttribute && up.hasAttribute('inert')) { up.removeAttribute('inert'); rec.reinert.push(up); }
      up = up.parentElement;
    }
    Array.prototype.forEach.call(document.body.children, function (ch) {
      if (ch === root || ch.contains(root) || ch.tagName === 'SCRIPT' || ch.hasAttribute('inert')) return;
      ch.setAttribute('inert', ''); rec.inerted.push(ch);
    });
    rwDialogs.push(rec);
    setTimeout(function () {
      var f = (opts.initial && root.querySelector(opts.initial)) || rwFocusables(root)[0] || root;
      if (f && f.focus) { if (f === root && !root.hasAttribute('tabindex')) root.setAttribute('tabindex', '-1'); f.focus({ preventScroll: true }); }
    }, 40);
  }
  function rwDialogClose(root) {
    var idx = -1;
    rwDialogs.forEach(function (r, i) { if (r.root === root) idx = i; });
    if (idx === -1) return;
    if (root.classList.contains('rw-search-ov')) root.dispatchEvent(new CustomEvent('rw:search-dismiss'));
    var rec = rwDialogs.splice(idx, 1)[0];
    rec.inerted.forEach(function (ch) { ch.removeAttribute('inert'); });
    (rec.reinert || []).forEach(function (ch) {
      /* alleen weer inert als een nog-openstaande dialoog hem inert had gezet */
      if (rwDialogs.some(function (r) { return r.inerted.indexOf(ch) !== -1; })) ch.setAttribute('inert', '');
    });
    // een nog openstaande dialog eronder houdt zijn eigen inert-set (die staat al)
    var t = rec.trigger;
    /* W7-1 gate r1 (A11y K1): trigger die inmiddels verborgen is (bv. knop in een gesloten drawer)
       -> focus-return naar de burger i.p.v. BODY */
    if (t && (!document.contains(t) || t.getClientRects().length === 0 || t.closest('[inert]'))) {
      var fb = document.getElementById('rw-burger'); /* getClientRects: ook correct voor fixed-position triggers */
      if (fb && fb.getClientRects().length > 0) t = fb;
    }
    if (t && t.focus && document.contains(t) && !t.closest('[inert]')) { try { t.focus({ preventScroll: true }); } catch (e) {} }
  }
  /* W7-1: helper ook voor de menu-drawer/zoekoverlay in header.liquid + Escape-voorrang bovenste dialoog */
  window.rwDialogOpen = rwDialogOpen;
  window.rwDialogClose = rwDialogClose;
  window.rwDialogTop = function () { return rwDialogs.length ? rwDialogs[rwDialogs.length - 1].root : null; };
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !rwDialogs.length) return;
    var root = rwDialogs[rwDialogs.length - 1].root;
    var f = rwFocusables(root);
    if (!f.length) { e.preventDefault(); return; }
    var first = f[0], last = f[f.length - 1], inside = root.contains(document.activeElement);
    if (e.shiftKey && (document.activeElement === first || !inside)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (document.activeElement === last || !inside)) { e.preventDefault(); first.focus(); }
  });
  var rwLiveEl = null, rwLiveTimer = null;
  function announce(msg) {
    if (!rwLiveEl) {
      rwLiveEl = document.createElement('div');
      rwLiveEl.id = 'rw-live'; rwLiveEl.setAttribute('role', 'status'); rwLiveEl.setAttribute('aria-live', 'polite');
      rwLiveEl.style.cssText = 'position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0;';
      document.body.appendChild(rwLiveEl);
    }
    rwLiveEl.textContent = '';
    clearTimeout(rwLiveTimer);
    rwLiveTimer = setTimeout(function () { rwLiveEl.textContent = msg; }, 50);
  }

  /* --------------------------------------------------------- mobile nav */
  function initMobileNav() {
    var nav = $('[data-rw-mobnav]');
    if (!nav) return;
    function open() { nav.hidden = false; lockScroll(true); }
    function close() { nav.hidden = true; lockScroll(false); }
    $$('[data-rw-menu-open]').forEach(function (b) { b.addEventListener('click', open); });
    $$('[data-rw-mobsearch]').forEach(function (b) {
      b.addEventListener('click', function () {
        var input = document.querySelector('.rw-header__mobile-search [data-rw-predictive], .rw-header__mobile-search input[name="q"]');
        if (input) { window.scrollTo({ top: 0, behavior: 'smooth' }); input.focus(); }
      });
    });
    nav.addEventListener('click', function (e) {
      if (e.target.closest('[data-rw-menu-close]') || e.target.matches('.rw-mobnav__overlay')) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !nav.hidden) close(); });
  }

  /* --------------------------------------------------------- cart drawer */
  /* W7-2 gate r4 (Mobile B1): losstaande dialooglagen (quick-shop, cart-drawer) delen één
     history-entry zodat de Android-terugknop de laag sluit i.p.v. de pagina te verlaten. Boven de
     zoekoverlay wordt niets gepusht — die laagvolgorde regelt de overlay-popstate in header.liquid. */
  var rwLayerHeld = false;
  function rwOvVisible() { var ov = document.getElementById('rw-search-ov'); return !!(ov && !ov.hidden); }
  function rwLayerPush() { if (rwOvVisible() || rwLayerHeld) return; try { history.pushState({ rwLayer: 1 }, ''); rwLayerHeld = true; } catch (e) {} }
  function rwLayerPop() { if (!rwLayerHeld) return; rwLayerHeld = false; try { history.back(); } catch (e) {} }
  /* W7-2 gate r6 (A11y B4): de menu-drawer heeft nu een eigen history-entry; opent de cart-drawer vanuit het menu, dan
     neemt hij die entry over i.p.v. er een nieuwe te pushen (anders zou de back() van het sluitende menu de cart-laag poppen). */
  window.rwLayerAdopt = function () { rwLayerHeld = true; };
  /* W7-2 gate r5 (E-com-tip): terugknop met cart-drawer boven de zoekoverlay sluit alleen de drawer */
  window.rwCartBackClose = function () { if (CartDrawer && CartDrawer.el && !CartDrawer.el.hidden) { rwLayerHeld = false; CartDrawer.close(); return true; } return false; };
  window.addEventListener('popstate', function () {
    if (rwOvVisible()) return; /* overlay-flow: header.liquid-popstate regelt de lagen */
    var qs = document.querySelector('[data-rw-quickshop]');
    if (qs && !qs.hidden && window.rwQuickShopBackClose) { rwLayerHeld = false; window.rwQuickShopBackClose(); return; }
    if (CartDrawer && CartDrawer.el && !CartDrawer.el.hidden) { rwLayerHeld = false; CartDrawer.close(); return; }
    rwLayerHeld = false; /* stale-guard: entry gepopt zonder open laag */
  });
  var CartDrawer = {
    el: null,
    mutationVersion: 0,
    refreshVersion: 0,
    pendingChanges: 0,
    concurrentChanges: false,
    reconcilePromise: null,
    changeFailureMessage: '',
    beginChange: function () {
      if (this.pendingChanges || this.reconcilePromise) this.concurrentChanges = true;
      this.pendingChanges += 1;
      return ++this.mutationVersion;
    },
    requestData: function (url, options, textOnly) {
      var ctrl = new AbortController(), timer, timedOut = false;
      var request = fetch(url, Object.assign({}, options || {}, { signal: ctrl.signal })).then(function (r) {
        return (textOnly ? r.text() : r.json()).then(function (data) {
          if (!r.ok) { var err = new Error((data && (data.description || data.message)) || 'Winkelwagen kon niet worden bijgewerkt.'); err.status = r.status; throw err; }
          return data;
        });
      });
      var deadline = new Promise(function (resolve, reject) { timer = setTimeout(function () { timedOut = true; ctrl.abort(); reject(new Error('Wijzigen is niet bevestigd. Controleer je winkelwagen.')); }, 8000); });
      return Promise.race([request, deadline]).catch(function (err) { if (timedOut) throw new Error('Wijzigen is niet bevestigd. Controleer je winkelwagen.'); throw err; }).finally(function () { clearTimeout(timer); });
    },
    finishChange: function () {
      this.pendingChanges = Math.max(0, this.pendingChanges - 1);
      return this.reconcileChanges();
    },
    reconcileChanges: function () {
      var self = this;
      if (self.pendingChanges || !self.concurrentChanges) return;
      if (self.reconcilePromise) return self.reconcilePromise;
      self.concurrentChanges = false;
      var version = self.mutationVersion;
      var failure = self.changeFailureMessage;
      var task = self.requestData(routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (cart) {
        if (version !== self.mutationVersion) { self.concurrentChanges = true; return; }
        if (!self.isCart(cart)) throw new Error('Controleer je winkelwagen voordat je het opnieuw probeert.');
        return bundleGuard(cart).then(function (guarded) {
          if (version !== self.mutationVersion) { self.concurrentChanges = true; return; }
          if (guarded && guarded.cart) cart = guarded.cart;
          updateCartCount(cart.item_count);
          var page = !!document.querySelector('.rw-cartpage');
          var render = page ? cartPageRerender() : self.refresh(guarded ? guarded.sections : null, cart, version);
          return render.then(function () {
            if (version !== self.mutationVersion) { self.concurrentChanges = true; return; }
            if (!page) self.restoreFocus();
            if (failure) { announce(failure); if (page) cartPageStatus(failure); if (self.changeFailureMessage === failure) self.changeFailureMessage = ''; }
            else { var message = 'Winkelwagen bijgewerkt: ' + cart.item_count + (cart.item_count === 1 ? ' artikel.' : ' artikelen.'); announce(message); if (page) cartPageStatus(message); }
          });
        });
      }).catch(function () {
        if (version !== self.mutationVersion) { self.concurrentChanges = true; return; }
        announce(failure || 'Controleer je winkelwagen voordat je het opnieuw probeert.');
        if (failure && self.changeFailureMessage === failure) self.changeFailureMessage = '';
      }).finally(function () {
        if (version === self.mutationVersion && !self.pendingChanges) $$('.rw-cartitem[aria-busy="true"], .rw-qtybox.is-busy, .rw-cartrow.is-busy').forEach(function (row) { row.classList.remove('is-busy'); row.removeAttribute('aria-busy'); });
        self.reconcilePromise = null;
        if (self.concurrentChanges && !self.pendingChanges) return self.reconcileChanges();
      });
      self.reconcilePromise = task;
      return task;
    },
    isCart: function (cart) { return !!cart && Array.isArray(cart.items) && Number.isInteger(cart.item_count) && cart.item_count >= 0; },
    itemKey: function (row) {
      var key = row && row.getAttribute('data-rw-cart-key');
      return key && key === key.trim() && !/^\d+$/.test(key) ? key : null;
    },
    rowForKey: function (root, key) {
      return key && $$('[data-rw-cart-key]', root).filter(function (row) { return row.getAttribute('data-rw-cart-key') === key; })[0];
    },
    restoreFocus: function () {
      var self = this;
      if (!self.el || self.el.hidden || (self.el.contains(document.activeElement) && document.activeElement !== document.body)) { self.refocus = null; return; }
      /* W10-1b A11y-gate B1: stepper-focus terug op dezelfde regel/knop (of de andere knop als die nu disabled is) */
      var rf = self.refocus; self.refocus = null;
      if (rf) { var rfRow = self.rowForKey(self.el, rf.key); var bx = rf.key ? rfRow && rfRow.querySelector('[data-rw-cart-qty]') : self.el.querySelector('[data-rw-cart-qty="' + rf.line + '"]'); var tb = bx && (bx.querySelector('[data-rw-qty-dir="' + rf.dir + '"]:not(:disabled)') || bx.querySelector('[data-rw-qty-dir]:not(:disabled)')); if (tb) { try { tb.focus({ preventScroll: true }); return; } catch (e) {} } }
      var t = self.el.querySelector('.rw-cartdrawer__empty a, .rw-cartdrawer__empty button') || self.el.querySelector('button[data-rw-cart-close]'); // de overlay-div draagt hetzelfde attribuut en is niet focusbaar
      if (t) { try { t.focus({ preventScroll: true }); } catch (e) {} }
    },
    init: function () {
      this.el = $('[data-rw-cartdrawer]');
      var self = this;
      $$('[data-rw-cart-open]').forEach(function (b) {
        b.addEventListener('click', function (e) {
          if (theme.settings && theme.settings.cartType === 'page') return; // let it navigate
          e.preventDefault();
          self.open();
        });
      });
      document.addEventListener('click', function (e) {
        if (!self.el) return;
        if (e.target.closest('[data-rw-cart-close]') || e.target.matches('.rw-cartdrawer__overlay')) self.close();
        var rm = e.target.closest('[data-rw-cart-remove]');
        if (rm) {
          e.preventDefault();
          /* W10-1b IxD-gate B6: pending-staat + snapshot voor Ongedaan maken (spiegel cartpagina) */
          var row0 = rm.closest('.rw-cartitem');
          if (row0 && row0.getAttribute('aria-busy') === 'true') return;
          if (row0) { row0.setAttribute('aria-busy', 'true'); self.undoSnap = { vid: row0.getAttribute('data-rw-vid'), key: self.itemKey(row0), qty: parseInt(row0.getAttribute('data-rw-iqty'), 10) || 1, title: row0.getAttribute('data-rw-title') || '' }; }
          self.changeLine(rm.getAttribute('data-rw-cart-remove'), 0);
        }
        // aantal-stepper (- N +) per regel: leest huidige qty, +/-1, zet absoluut aantal
        var qb = e.target.closest('[data-rw-qty-dir]');
        if (qb && !qb.disabled) {
          e.preventDefault();
          var box = qb.closest('[data-rw-cart-qty]');
          if (box) {
            var line = box.getAttribute('data-rw-cart-qty');
            var valEl = box.querySelector('[data-rw-qty-val]');
            var cur = parseInt((valEl && valEl.getAttribute('data-rw-qty-val')) || '1', 10) || 1;
            var qmax = parseInt(box.getAttribute('data-rw-qty-max') || '0', 10);
            var next = qb.getAttribute('data-rw-qty-dir') === 'inc' ? cur + 1 : cur - 1;
            if (next < 1) { if (box.classList.contains('is-busy')) return; box.classList.add('is-busy'); box.setAttribute('aria-busy', 'true'); self.changeLine(line, 0); return; } // W15-1 gate r2: min bij aantal 1 = verwijderen (prullenbak), zoals op de winkelwagenpagina
            if (qmax > 0 && next > qmax) return;  // niet boven voorraad
            if (box.classList.contains('is-busy')) return; // W10-1b (IxD W6-5 r6): tweede snelle tik tijdens de verversing wordt genegeerd
            box.classList.add('is-busy'); box.setAttribute('aria-busy', 'true'); // zichtbare pending-staat tot de her-render
            self.refocus = { line: line, key: self.itemKey(box.closest('.rw-cartitem')), dir: qb.getAttribute('data-rw-qty-dir') }; // W10-1b A11y-gate B1: na de her-render terug op dezelfde knop (was: 'Sluiten')
            self.changeLine(line, next);
          }
        }
        // upsell met meerdere condities: knop klapt de keuze in de drawer zelf uit (geen navigatie
        // naar de productpagina meer - Sjaak 2026-08-09). Chip erin voegt daarna direct toe.
        var pick = e.target.closest('[data-rw-upsell-pick]');
        if (pick) {
          e.preventDefault();
          var prow = pick.closest('.rw-upsell__item');
          var opts = prow && prow.querySelector('.rw-upsell__opts');
          if (opts) {
            var openen = opts.hidden;
            if (!opts.id) opts.id = 'rw-upsell-opts-' + Math.random().toString(36).slice(2, 8);
            setTimeout(function () { if (!opts.hidden) { try { opts.scrollIntoView({ block: 'nearest' }); } catch (e5) {} } }, 30); /* W10-1b Mobile-gate B2: chips verschenen onder de sticky voet */
            pick.setAttribute('aria-controls', opts.id);
            // W6-3 r6 (Mobile): één disclosure tegelijk open
            $$('.rw-upsell__opts').forEach(function (o) { if (o !== opts && !o.hidden) { o.hidden = true; var pb = o.closest('.rw-upsell__item'); var b2 = pb && pb.querySelector('[data-rw-upsell-pick]'); if (b2) b2.setAttribute('aria-expanded', 'false'); } });
            opts.hidden = !openen;
            pick.setAttribute('aria-expanded', openen ? 'true' : 'false');
          }
          return;
        }
        // W6-3 r6 (Mobile): tik buiten een open conditie-disclosure sluit hem
        if (!e.target.closest('.rw-upsell__item')) {
          $$('.rw-upsell__opts').forEach(function (o) { if (!o.hidden) { o.hidden = true; var pb = o.closest('.rw-upsell__item'); var b2 = pb && pb.querySelector('[data-rw-upsell-pick]'); if (b2) b2.setAttribute('aria-expanded', 'false'); } });
        }
        // upsell: "Toevoegen" voegt toe; drawer her-rendert vanzelf. Op de cart-PAGINA herladen we
        // de pagina zodat de nieuwe regel ook in de paginalijst verschijnt.
        var up = e.target.closest('[data-rw-upsell-add]');
        if (up) {
          e.preventDefault();
          if (up.classList.contains('is-done') || up.classList.contains('is-loading')) return; // W6-5 IxD r5 (B3) + W10-1b (IxD r7): guard vóór de bezig-staat — de dubbelklik-guard stond ná is-loading, waardoor een tweede klik de knop op 'bezig' liet staan
          up.classList.add('is-loading');
          up.setAttribute('aria-busy', 'true');
          var onCartPage = !!document.getElementById('rw-cart-form');
          if (!onCartPage) CartDrawer.keepUpsell = up; // W6-5 IxD r5 (B3): het upsell-blok blijft staan bij de verversing (focus + bevestiging behouden, lijst verspringt niet)
          addToCart([{ id: parseInt(up.getAttribute('data-rw-upsell-add'), 10), quantity: 1 }], !onCartPage)
            .then(function () {
              if (onCartPage) {
                return cartPageRerender().then(function () {
                  cartPageStatus('Toegevoegd aan je winkelwagen.'); // sr-only; de toast is het visuele kanaal (W6-3 r6: één bevestiging)
                  cartPageToast('Toegevoegd aan je winkelwagen');
                  return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { updateCartCount(c.item_count); }).catch(function () {});
                });
              }
              up.classList.remove('is-loading');
              up.removeAttribute('aria-busy');
              up.classList.add('is-done');
              up.setAttribute('aria-disabled', 'true');
              up.textContent = '✓ Toegevoegd'; // W6-5 IxD r5 (B3): blijft staan (het upsell-blok wordt niet vervangen); focus blijft op de knop
              (function () { var it1 = up.closest('.rw-upsell__item'); var nm = it1 && it1.querySelector('.rw-upsell__name'); var t1 = nm ? nm.textContent.trim() : ''; up.setAttribute('aria-label', 'Toegevoegd aan je winkelwagen' + (t1 ? ': ' + t1 : '')); announce('Toegevoegd aan je winkelwagen' + (t1 ? ': ' + t1 : '') + '.'); })(); // W10-1b A11y-gate B2: naam = zichtbare tekst, en de toevoeging wordt aangekondigd
              /* W8-2 (gate-tip W8-1 E-com r4): het blok-label 'Nog niet in je mandje' mag niet boven een
                 toegevoegd item blijven claimen — zijn alle items toegevoegd, dan wisselt het label. */
              (function () {
                var bx = up.closest('[data-rw-upsell]');
                if (!bx) return;
                /* W10-1b (E-com W6-5 r3 / W8-1 r4): het toegevoegde item wisselt van 'nog niet'-tint naar mandje-wit; bij een conditie-chip
                   wordt ook de kiesknop de bevestiging en klapt de chiprij dicht; de sub-regel telt wat er nog niet in zit */
                var it0 = up.closest('.rw-upsell__item');
                if (it0) {
                  it0.classList.add('is-added');
                  var pickBtn = it0.querySelector('[data-rw-upsell-pick]'), optsBox = it0.querySelector('.rw-upsell__opts');
                  if (pickBtn && !pickBtn.classList.contains('is-done')) { pickBtn.classList.add('is-done'); pickBtn.setAttribute('aria-disabled', 'true'); pickBtn.setAttribute('aria-expanded', 'false'); pickBtn.textContent = '\u2713 Toegevoegd'; }
                  if (optsBox && up.classList.contains('rw-upsell__opt')) { optsBox.hidden = true; try { pickBtn.focus({ preventScroll: true }); } catch (e4) {} }
                }
                var items = $$('.rw-upsell__item', bx);
                var rest = items.filter(function (it) { return !it.classList.contains('is-added'); }).length;
                var sub = bx.querySelector('.rw-upsell__sub');
                if (sub) sub.textContent = rest === 0 ? 'Alles hierboven staat nu in je winkelwagen' : (rest === 1 ? 'Nog 1 suggestie om toe te voegen' : 'Nog ' + rest + ' suggesties om toe te voegen');
              })();
              if (!document.activeElement || document.activeElement === document.body) { try { up.focus({ preventScroll: true }); } catch (e2) {} }
            })
            .catch(function (err) { CartDrawer.keepUpsell = null; up.classList.remove('is-loading'); up.removeAttribute('aria-busy'); addFail(up, err); });
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        if (self.el && !self.el.hidden && window.rwDialogTop && window.rwDialogTop() !== self.el) return; // W7-1: alleen de bovenste dialoog reageert op Escape
        // W6-3 r6 (Mobile): Escape sluit eerst een open conditie-disclosure, daarna pas de drawer
        var openOpts = $$('.rw-upsell__opts').filter(function (o) { return !o.hidden; });
        if (openOpts.length) { openOpts.forEach(function (o) { o.hidden = true; var pb = o.closest('.rw-upsell__item'); var b2 = pb && pb.querySelector('[data-rw-upsell-pick]'); if (b2) { b2.setAttribute('aria-expanded', 'false'); b2.focus(); } }); return; }
        if (self.el && !self.el.hidden) self.close();
      });
    },
    open: function (opts) { if (this.el && this.el.hidden) { this.el.hidden = false; rwLayerPush(); lockScroll(true); upsellFill(this.el); $$('[data-rw-upsell]', this.el).forEach(updateUpsellSub); rwDialogOpen(this.el, { initial: '.rw-cartdrawer__panel [data-rw-cart-close]', trigger: opts && opts.trigger }); } },
    close: function () { if (this.el && !this.el.hidden) { this.el.hidden = true; rwLayerPop(); lockScroll(false); rwDialogClose(this.el); } },
    refresh: function (sections, cart, version) {
      var self = this;
      var refreshVersion = ++self.refreshVersion;
      document.querySelectorAll('.rw-adderr').forEach(function (n) { n.remove(); }); // W6-5 IxD r4: 'zit al in je winkelwagen' mag niet blijven staan na een cart-wijziging
      var supplied = sections && sections['cart-drawer'];
      var usable = typeof supplied === 'string' && new DOMParser().parseFromString(supplied, 'text/html').querySelector('#rw-cartdrawer-contents');
      if (usable && cart) {
        var state = cart.item_count + '|' + cart.total_price + '|' + (cart.items || []).map(function (item) { return item.key + ':' + item.quantity + ':' + item.final_line_price + ';'; }).join('');
        if (usable.getAttribute('data-rw-cart-state') !== state) usable = null;
      }
      if (version != null && version !== self.mutationVersion) usable = null;
      var response = usable ? Promise.resolve(sections) : self.requestData(routes.root + '?sections=cart-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      return response
        .then(function (data) {
          if (refreshVersion !== self.refreshVersion || (version != null && version !== self.mutationVersion)) return;
          var html = data['cart-drawer'];
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('#rw-cartdrawer-contents');
          var current = $('#rw-cartdrawer-contents', self.el);
          if (fresh && current) {
            var count = fresh.querySelector('[data-rw-cart-count]');
            var freshCount = count && /^\d+$/.test(count.textContent.trim()) ? +count.textContent.trim() : null;
            var keep = self.keepUpsell; self.keepUpsell = null;
            var keepBox = (keep && current.contains(keep)) ? keep.closest('[data-rw-upsell]') : null;
            if (keepBox && fresh.querySelector('.rw-cartdrawer__items') && current.querySelector('.rw-cartdrawer__items')) {
              // W6-5 IxD r5 (B3): na een upsell-toevoeging alleen kop, regels en voet verversen; het upsell-blok (met de
              // focus en de 'Toegevoegd'-knop) blijft in de DOM: geen focusverlies, geen verspringende lijst
              ['.rw-cartdrawer__head', '.rw-cartdrawer__foot'].forEach(function (sel) {
                var a = current.querySelector(sel), b = fresh.querySelector(sel);
                if (a && b) a.replaceWith(b); else if (a) a.remove(); else if (b) current.appendChild(b);
              });
              var itemsBox = current.querySelector('.rw-cartdrawer__items');
              var oldRows = $$('.rw-cartitem', itemsBox);
              var anchor = oldRows.length ? oldRows[0] : itemsBox.firstChild;
              // W6-5 IxD r6: de nieuwe regel komt bovenaan de lijst en teleporteerde de geklikte
              // '✓ Toegevoegd'-knop 118-132px omlaag. Twee vangnetten: (1) de nieuwe rij groeit
              // geanimeerd in (de beweging is volgbaar i.p.v. een frame-sprong; uit bij
              // prefers-reduced-motion), (2) zolang de lijst beweegt wordt de scrollpositie per
              // frame bijgestuurd zodat de knop blijft staan waar dat kan (scrollbare lijst).
              var keepTopBefore = keep.getBoundingClientRect().top;
              var freshRows = $$('.rw-cartitem', fresh);
              freshRows.forEach(function (row) { itemsBox.insertBefore(row, anchor); });
              oldRows.forEach(function (r) { r.remove(); });
              var emptyState = current.querySelector('.rw-cartdrawer__empty'); if (emptyState) emptyState.remove();
              var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
              if (freshRows.length > oldRows.length && freshRows.length && !reduceMotion) {
                var nr = freshRows[0];
                var nrH = nr.getBoundingClientRect().height;
                nr.style.overflow = 'hidden'; nr.style.height = '0px'; nr.style.marginBottom = '-12px'; nr.style.opacity = '0';
                nr.style.transition = 'height .22s ease, margin-bottom .22s ease, opacity .18s ease .08s';
                // dubbele rAF (gate-tip IxD r7): de ingeklapte staat krijgt eerst een eigen paint-frame,
                // anders delen DOM-insert en animatiestart één frame en is de eerste stap de grootste
                requestAnimationFrame(function () { requestAnimationFrame(function () { nr.style.height = nrH + 'px'; nr.style.marginBottom = '0px'; nr.style.opacity = '1'; }); });
                setTimeout(function () { ['height', 'marginBottom', 'overflow', 'opacity', 'transition'].forEach(function (k) { nr.style[k] = ''; }); }, 320);
              }
              var holdT0 = (window.performance && performance.now) ? performance.now() : 0;
              (function holdKeep() {
                itemsBox.scrollTop += keep.getBoundingClientRect().top - keepTopBefore;
                if (holdT0 && performance.now() - holdT0 < 360) requestAnimationFrame(holdKeep);
              })();
            } else {
              current.innerHTML = fresh.innerHTML;
            }
            /* W10-1b IxD-gate B6: na verwijderen een Ongedaan maken-rij bovenin (of in de lege staat), focus erop */
            (function () {
              var snap = self.undoSnap; self.undoSnap = null;
              if (!snap || !snap.vid) return;
              var host = current.querySelector('.rw-cartdrawer__items') || current.querySelector('.rw-cartdrawer__empty');
              if (!host) return;
              var u = document.createElement('div'); u.className = 'rw-cartdrawer__undo'; u.setAttribute('role', 'status');
              u.innerHTML = '<span>Verwijderd: ' + escHtml(snap.title) + '</span><button type="button" class="rw-cartdrawer__undobtn">Ongedaan maken</button>';
              host.insertBefore(u, host.firstChild);
              var ub = u.querySelector('button');
              ub.addEventListener('click', function () {
                if (ub.disabled) return; ub.disabled = true; ub.textContent = 'Bezig\u2026';
                addToCart([{ id: parseInt(snap.vid, 10), quantity: snap.qty }], true)
                  .then(function () {
                    announce(snap.title + ' staat weer in je winkelwagen.');
                    /* W10-1b IxD r2 (B1): focus niet op BODY laten vallen — naar de teruggezette regel (naamlink), anders de sluitknop */
                    var t7 = self.el && (self.el.querySelector('.rw-cartitem__name') || self.el.querySelector('button[data-rw-cart-close]'));
                    if (t7) { try { t7.focus({ preventScroll: true }); } catch (e7) {} }
                  })
                  .catch(function () { ub.disabled = false; ub.textContent = 'Ongedaan maken'; addFail(ub, null); });
              });
              try { ub.focus({ preventScroll: true }); } catch (e6) {}
            })();
            if (freshCount !== null) updateCartCount(freshCount);
          }
          upsellFill(self.el);
        })
        .catch(function () {});
    },
    changeLine: function (line, qty) {
      var self = this;
      var row = self.el && self.el.querySelector('.rw-cartitem[data-rw-line="' + parseInt(line, 10) + '"]');
      var key = self.itemKey(row);
      var oldError = row && row.querySelector('[data-rw-cart-error]'); if (oldError) oldError.remove();
      var version = key ? self.beginChange() : self.mutationVersion;
      var response = key ? self.requestData(routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty, sections: ['cart-drawer'], sections_url: routes.root })
      }) : Promise.reject(new Error('Ververs je winkelwagen en probeer het opnieuw.'));
      return response.then(function (cart) { if (!self.isCart(cart)) throw new Error('Controleer je winkelwagen voordat je het opnieuw probeert.'); if (version !== self.mutationVersion) self.concurrentChanges = true; if (self.concurrentChanges) return; return bundleGuard(cart).then(function (guarded) { if (version !== self.mutationVersion) self.concurrentChanges = true; if (self.concurrentChanges) return; if (guarded && guarded.cart) cart = guarded.cart; updateCartCount(cart.item_count); announce(qty === 0 ? 'Product verwijderd uit je winkelwagen. Winkelwagen: ' + cart.item_count + (cart.item_count === 1 ? ' artikel.' : ' artikelen.') : 'Aantal bijgewerkt naar ' + qty + '. Winkelwagen: ' + cart.item_count + (cart.item_count === 1 ? ' artikel.' : ' artikelen.')); return self.refresh(guarded ? guarded.sections : cart.sections, cart, version).then(function () {
          if (version !== self.mutationVersion) { self.concurrentChanges = true; return; }
          // W6-5 IxD r3: na verwijderen verdween de knop met de focus (BODY binnen een open modal) -> lege staat: 'Verder winkelen', anders sluitknop
          self.restoreFocus();
        }); }); })
        .catch(function (err) {
          if (key && (!(err && err.status) || err.status === 400)) self.concurrentChanges = true;
          if (key && self.concurrentChanges) self.changeFailureMessage = (err && err.message) || 'Controleer je winkelwagen.';
          if (!self.el) return;
          if (row) {
            $$('.rw-qtybox.is-busy', row).forEach(function (bx2) { bx2.classList.remove('is-busy'); bx2.removeAttribute('aria-busy'); });
            row.removeAttribute('aria-busy');
            if (self.undoSnap && self.undoSnap.key === key) self.undoSnap = null;
            var error = row.querySelector('[data-rw-cart-error]');
            if (!error) { error = document.createElement('p'); error.setAttribute('data-rw-cart-error', ''); error.setAttribute('role', 'alert'); row.appendChild(error); }
            error.textContent = (err && err.message) || 'Wijzigen is niet gelukt. Controleer je winkelwagen en probeer het opnieuw.';
          }
          if (version === self.mutationVersion) self.refocus = null;
        }).finally(function () {
          if (row && (!self.concurrentChanges || self.pendingChanges <= 1)) { $$('.rw-qtybox.is-busy', row).forEach(function (box) { box.classList.remove('is-busy'); box.removeAttribute('aria-busy'); }); row.removeAttribute('aria-busy'); }
          return key ? self.finishChange() : null;
        });
    }
  };

  /* bundel-waker: BUNDEL20 is alleen geldig zolang ALLE items van de toegevoegde bundel
     nog in de winkelwagen zitten. Item weg -> discount-cookie overschrijven met een
     niet-bestaande code zodat de echte prijzen terugkomen bij het afrekenen. */
  function bundleGuard(cart) {
    var raw = null;
    try { raw = JSON.parse(localStorage.getItem('rwBundle') || 'null'); } catch (e) {}
    if (!raw || !raw.length) return Promise.resolve(null);
    var check = function (c) {
      var present = (c.items || []).map(function (i) { return i.variant_id || i.id; });
      var complete = raw.every(function (vid) { return present.indexOf(vid) !== -1; });
      if (!complete) {
        localStorage.removeItem('rwBundle');
        // discount-cookie wissen (alle domein/pad-varianten) zodat de echte prijzen terugkomen
        var exp = ';expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/';
        document.cookie = 'discount_code=' + exp;
        document.cookie = 'discount_code=' + exp + ';domain=' + location.hostname;
        document.cookie = 'discount_code=' + exp + ';domain=.' + location.hostname.split('.').slice(-2).join('.');
        // de code hangt ook server-side aan de cart: expliciet losmaken
        return CartDrawer.requestData(routes.root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: '', sections: ['cart-drawer'], sections_url: routes.root }) })
          .then(function (updated) { return { cart: updated, sections: updated.sections }; })
          .catch(function () { return { cart: null, sections: null }; });
      }
    };
    if (cart && cart.items) return Promise.resolve(check(cart));
    return CartDrawer.requestData(routes.cart + '.js').then(check).catch(function () { return null; });
  }
  window.RewayBundleGuard = bundleGuard;

  /* cart-upsell vullaag: als de deterministische server-regels minder dan het maximum
     opleverden (bv. boeken), aanvullen met Shopify's per-product Recommendations API
     (gedragsdata, geen willekeur). Games alleen zelfde platform; nooit consoles,
     nooit items die al in de cart zitten of al voorgesteld zijn. */
  /* JS-spiegel van snippets/rw-optienaam.liquid: de Shopify-optienaam verschilt per product
     ("Conditie" bij sterproducten, "Variant" bij games, "Kleur", of een eigen vraag), dus nooit
     "conditie" hardcoden. Bekende enkelvoudige namen -> "Kies een {naam}", de rest letterlijk. */
  var RW_OPT_SINGLES = ['conditie', 'variant', 'kleur', 'maat', 'model', 'staat', 'systeem', 'editie', 'formaat', 'opslag', 'uitvoering', 'type'];
  var RW_OPT_NL = { size: 'maat', colour: 'kleur', color: 'kleur', system: 'systeem', condition: 'conditie' };
  function optieKies(p) {
    var opties = (p && p.options) || [];
    var eerste = opties[0];
    var raw = (typeof eerste === 'string' ? eerste : (eerste && eerste.name) || '').trim();
    var l = raw.toLowerCase();
    if (!l || l === 'title') { raw = 'Variant'; l = 'variant'; }
    if (RW_OPT_NL[l]) l = RW_OPT_NL[l];
    if (opties.length > 1) return opties.map(function (o) { return (typeof o === 'string' ? o : (o && o.name) || '').trim(); }).join(' / '); /* Sjaak 2026-10-13: nooit het loze 'optie', maar de echte optienamen ("Kleur / Maat") - zie rw-optienaam.liquid */
    if (RW_OPT_SINGLES.indexOf(l) !== -1) return 'Kies een ' + l;
    return raw;
  }

  function updateUpsellSub(bx) { /* W10-1b E-com-gate tip 1: telling ook initieel */
    var items = $$('.rw-upsell__item', bx);
    var rest = items.filter(function (it) { return !it.classList.contains('is-added'); }).length;
    var sub = bx.querySelector('.rw-upsell__sub');
    if (sub && items.length) sub.textContent = rest === 0 ? 'Alles hierboven staat nu in je winkelwagen' : (rest === 1 ? 'Nog 1 suggestie om toe te voegen' : 'Nog ' + rest + ' suggesties om toe te voegen');
  }
  function upsellFill(root) {
    $$('[data-rw-upsell]', root).forEach(function (bx) { upsellFillBox(bx); updateUpsellSub(bx); });
  }
  function upsellFillBox(box) {
    if (!box || box.dataset.rwFilled) return;
    var need = parseInt(box.dataset.rwUpsellNeed || '0', 10);
    if (need <= 0) return;
    var src = [];
    try { src = JSON.parse(box.dataset.rwUpsellSrc || '[]'); } catch (e) {}
    if (!src.length) return;
    box.dataset.rwFilled = '1';
    var exclude = box.dataset.rwUpsellCart || '|';
    $$('[data-rw-upsell-handle]', box).forEach(function (r) { exclude += (r.dataset.rwUpsellHandle || '') + '|'; });
    var list = box.querySelector('.rw-upsell__list');
    if (!list) return;
    function tryNext(i) {
      if (need <= 0 || i >= src.length) return;
      var s = src[i];
      fetch('/recommendations/products?section_id=rw-related&product_id=' + s.id + '&limit=8&intent=related')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (t) {
          if (!t) { tryNext(i + 1); return; }
          var d = document.createElement('div');
          d.innerHTML = t;
          var cards = Array.prototype.slice.call(d.querySelectorAll('[data-rw-rec]')).filter(function (c) {
            if (c.dataset.rwRecType === 'Consoles') return false;
            if (s.kind === 'game' && (c.dataset.rwRecType !== 'Games' || (c.dataset.rwRecTags || '').indexOf('|' + s.plat + '|') === -1)) return false;
            var a = c.querySelector('a[href*="/products/"]');
            if (!a) return false;
            var h = (a.getAttribute('href') || '').split('?')[0].split('/products/')[1];
            if (!h || exclude.indexOf('|' + h + '|') !== -1) return false;
            c.__rwHandle = h;
            return true;
          });
          function addOne(j) {
            if (need <= 0 || j >= cards.length) { tryNext(i + 1); return; }
            var h = cards[j].__rwHandle;
            fetch('/products/' + h + '.js')
              .then(function (r) { return r.ok ? r.json() : null; })
              .then(function (p) {
                var v = p ? (p.variants || []).filter(function (x) { return x.available; })[0] : null;
                if (!v) { addOne(j + 1); return; }
                /* W8-2 (gate-tip W8-1 E-com r4/r5): sibling-listings delen soms exact dezelfde titel —
                   dezelfde titel twee keer aanbevelen leest als een glitch. */
                var dup = $$('.rw-upsell__name', list).some(function (n) { return n.textContent.trim() === p.title.trim(); });
                if (dup) { addOne(j + 1); return; }
                // zelfde opbouw als snippets/rw-cart-upsell-item.liquid: 1 beschikbare variant -> direct
                // toevoegen; meerdere condities -> chips die in de drawer zelf uitklappen (geen navigatie)
                var avail = (p.variants || []).filter(function (x) { return x.available; });
                var kiesLabel = optieKies(p);   // "Kies een variant" / "Kies een conditie" / eigen optienaam
                var knop, opts = '';
                if (avail.length > 1) {
                  knop = '<button type="button" class="rw-upsell__add" data-rw-upsell-pick aria-expanded="false" aria-controls="rw-upsell-opts-' + p.id + '" aria-label="' + escHtml(kiesLabel.indexOf('Kies een ') === 0 ? kiesLabel : 'Kies een optie') + ' voor ' + escHtml(p.title) + ' en voeg toe">' +
                         '<span class="rw-upsell__plus" aria-hidden="true">+</span>' + escHtml(kiesLabel) +
                         '<svg class="rw-upsell__chev" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg></button>';
                  var taalHelp = (box.getAttribute('data-rw-taalhelp') || '').trim(); var taalV = avail.filter(function (av) { return /andere taal/i.test(av.title || ''); })[0]; /* W10-1b Mobile-gate B5: zelfde uitleg als de Liquid-rijen */
                  opts = '<div class="rw-upsell__opts" id="rw-upsell-opts-' + p.id + '" hidden><span class="rw-upsell__optlabel">' + escHtml(kiesLabel) + '</span>' +
                         avail.map(function (av) {
                           return '<button type="button" class="rw-upsell__opt" data-rw-upsell-add="' + av.id + '">' +
                                  escHtml(av.title) + ' <b>' + moneyEuro(av.price) + '</b></button>';
                         }).join('') + (taalV && taalHelp ? '<span class="rw-upsell__opthelp"><b>' + escHtml(taalV.title) + '</b>: ' + escHtml(taalHelp) + '</span>' : '') + '</div>';
                } else {
                  knop = '<button type="button" class="rw-upsell__add" data-rw-upsell-add="' + v.id + '" aria-label="Toevoegen: ' + escHtml(p.title) + ' aan je winkelwagen">' +
                         '<span class="rw-upsell__plus" aria-hidden="true">+</span>Toevoegen</button>';
                }
                var img = p.featured_image ? String(p.featured_image) : '';
                if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=160'; // 56px @2x = 112 nodig; 96 was wazig
                var row = document.createElement('div');
                row.className = 'rw-upsell__item';
                row.setAttribute('data-rw-upsell-handle', h);
                row.innerHTML =
                  '<a href="/products/' + h + '" class="rw-upsell__img" aria-hidden="true" tabindex="-1">' + (img ? '<img src="' + img + '" alt="" width="56" height="56" loading="lazy">' : '') + '</a>' + /* W10-1b A11y-gate B3 */
                  '<div class="rw-upsell__body"><a href="/products/' + h + '" class="rw-upsell__name">' + escHtml(p.title) + '</a>' +
                  (avail.length === 1 && v.title && v.title !== 'Default Title' ? '<span class="rw-upsell__cond">' + escHtml(v.title) + '</span>' : '') +
                  '<div class="rw-upsell__row"><span class="rw-upsell__price">' + (avail.length > 1 && Math.min.apply(null, avail.map(function (a) { return a.price; })) !== Math.max.apply(null, avail.map(function (a) { return a.price; })) ? 'vanaf ' + moneyEuro(Math.min.apply(null, avail.map(function (a) { return a.price; }))) : moneyEuro(v.price)) + '</span>' + knop + '</div></div>' + opts;
                list.appendChild(row);
                exclude += h + '|';
                need -= 1;
                box.classList.remove('is-empty');
                updateUpsellSub(box); /* W15-2c r2 (Friction B3): de telling liep alleen over de server-side kaarten — een JS-bijgevulde kaart telde niet mee ('Nog 1 suggestie' boven twee kaarten) */
                addOne(j + 1);
              })
              .catch(function () { addOne(j + 1); });
          }
          addOne(0);
        })
        .catch(function () { tryNext(i + 1); });
    }
    tryNext(0);
  }

  function updateCartCount(n) {
    var panel = document.getElementById('rw-cartdrawer-contents'); // W6-5 IxD r5-tip (T4): dialoognaam met aantal
    if (panel) panel.setAttribute('aria-label', 'Winkelwagen, ' + n + (n === 1 ? ' artikel' : ' artikelen'));
    $$('[data-rw-cart-count]').forEach(function (el) {
      el.textContent = n;
      // W6-3 r5: alleen de badges verbergen op 0 (klassecheck matchte nooit); de drawer-titel 'Winkelwagen · 0' blijft
      if (el.classList.contains('rw-cart__count') || el.classList.contains('rw-micart__badge')) el.hidden = n === 0;
    });
  }
  /* W15-2c r5 (Edge B1): na browser-Back (bfcache of HTTP-cache) toonde de header de server-gerenderde teller van vóór het toevoegen (0 bij 1 artikel);
     de verkoopwinkel en de favorietenbadge synchroniseren wél. Bij back/forward de echte stand uit /cart.js overnemen. */
  window.addEventListener('pageshow', function (e) {
    var nav = (window.performance && performance.getEntriesByType) ? performance.getEntriesByType('navigation')[0] : null;
    if (!(e.persisted || (nav && nav.type === 'back_forward'))) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).then(function (c) { if (c && typeof c.item_count === 'number') updateCartCount(c.item_count); }).catch(function () {});
  });

  /* ------------------------------------------------------- add to cart */
  function addToCart(items, openDrawer) {
    var addTrigger = document.activeElement; // focus keert hier terug als de drawer sluit (W6-5)
    var version = ++CartDrawer.mutationVersion;
    return fetch(routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items, sections: ['cart-drawer'], sections_url: routes.root })
    }).then(function (r) {
        // W6-5 IxD r3: een 422 (voorraadmaximum) of 5xx werd als succes behandeld -> 'Toegevoegd' zonder dat er iets veranderde
        return r.json().catch(function () { return null; }).then(function (j) {
          if (!r.ok) { var err = new Error((j && (j.description || j.message)) || 'Toevoegen is niet gelukt.'); err.status = r.status; err.body = j; throw err; }
          return j;
        });
      })
      .then(function (added) {
        var addedId = (items && items[0]) ? items[0].id : null;
        return fetch(routes.cart + '.js').then(function (r) { return r.json(); }).then(function (cart) {
          return bundleGuard(cart).then(function (guarded) {
          if (guarded && guarded.cart) cart = guarded.cart;
          if (version === CartDrawer.mutationVersion) updateCartCount(cart.item_count);
          // titel/variant/foto/prijs uit cart.js (centen, betrouwbaar); /cart/add geeft prijzen als strings in hele euro's
          var line = null;
          if (addedId != null && cart.items) line = cart.items.filter(function (x) { return x.id === addedId || x.variant_id === addedId; })[0];
          if (!line) line = (added && added.items) ? added.items[0] : added;
          // staat de quick-shop open? eerst dat paneel sluiten, dan de popup net erna tonen
          // W6-5 (één bevestigingskanaal): opent de drawer, dan is de drawer de bevestiging —
          // de fullscreen popup verscheen er tegelijk overheen (dubbel, en hij bedekte de pagina).
          // De popup blijft het kanaal voor flows die de drawer niet openen.
          var qs = document.querySelector('[data-rw-quickshop]');
          var qsTrigger = null, qsOpen = !!(qs && !qs.hidden && QuickShop);
          if (qsOpen) qsTrigger = (rwDialogs.length ? rwDialogs[rwDialogs.length - 1].trigger : null);
          if (openDrawer === false) { if (qsOpen) { QuickShop.hide(); qsOpen = false; } if (!document.getElementById('rw-cart-form')) showAdded(line, cart); }
          announce('Toegevoegd aan je winkelwagen: ' + ((line && (line.product_title || line.title)) || 'product') + '. Winkelwagen: ' + cart.item_count + (cart.item_count === 1 ? ' artikel.' : ' artikelen.'));
          // W6-5 IxD r5-tip (T1): de quick-shop blijft (met bezig-knop) staan tot de drawer-render binnen is en sluit in
          // dezelfde tik als de drawer opent; eerder zat er ~250 ms zonder enige overlay tussen
          return (version === CartDrawer.mutationVersion ? CartDrawer.refresh(guarded ? guarded.sections : added && added.sections, cart, version) : Promise.resolve()).then(function () {
            if (version !== CartDrawer.mutationVersion) { CartDrawer.concurrentChanges = true; return CartDrawer.reconcileChanges(); }
          }).then(function () {
            if (qsOpen && !qs.hidden) QuickShop.hide();
            if (openDrawer !== false) CartDrawer.open({ trigger: (addTrigger && document.contains(addTrigger)) ? addTrigger : qsTrigger }); // fallback: de quick-shop-knop verdween met de dialog, focus keert dan terug op de kaartknop
          });
          });
        });
      });
  }

  /* W6-5 IxD r3: mislukt toevoegen was stil (geen tekst, geen alert, geen herstelactie). Een zichtbare
     role=alert-melding bij de knop, met een echte vervolgstap: opnieuw proberen (netwerk) of naar de
     winkelwagen (voorraadmaximum: het laatste exemplaar zit er al in). */
  var ADDERR_HOST = '.rw-qs__form, [data-rw-add-form], .rw-upsell__item, .rw-cartitem, .rw-pcard, .rw-stickybar, .rw-bnd';
  function addFail(btn, err) {
    var status = err && err.status;
    var max = status === 422;
    /* W8-1 gate (Buyer r2-B2): een 422 zonder Shopify-description is niet per se een voorraadmaximum
       (ook: uitverkochte variant via deeplink) — de vaste claim "zit al in je winkelwagen" was dan
       onwaar bij een lege winkelwagen. Neutrale fallback die beide oorzaken dekt. */
    var msg = max
      ? ((err.body && err.body.description) || 'Dit exemplaar kan niet (nog een keer) worden toegevoegd: het is uitverkocht of zit al in je winkelwagen.')
      : 'Toevoegen is niet gelukt. Controleer je verbinding en probeer het opnieuw.';
    announce(msg);
    if (!btn) return;
    var host = btn.closest(ADDERR_HOST) || btn.parentNode;
    var old = host.querySelector('.rw-adderr'); if (old) old.remove();
    var box = document.createElement('div');
    box.className = 'rw-adderr'; box.setAttribute('role', 'alert');
    box.innerHTML = '<span class="rw-adderr__t"></span>' + (max
      ? '<a class="rw-adderr__act" href="' + routes.cart + '">Bekijk winkelwagen</a>'
      : '<button type="button" class="rw-adderr__act" data-rw-adderr-retry>Opnieuw proberen</button>');
    box.querySelector('.rw-adderr__t').textContent = msg;
    (btn.closest('.rw-pdp__buyrow') || btn).insertAdjacentElement('afterend', box); // IxD r4-tip: onder de hele koopregel, niet naast de knop (die rekte mee tot 107px)
    var retry = box.querySelector('[data-rw-adderr-retry]');
    if (retry) retry.addEventListener('click', function () { box.remove(); try { btn.focus({ preventScroll: true }); } catch (e) {} btn.click(); }); // IxD r4: focus eerst op de koopknop, zodat de drawer daarheen terugkeert
    try { btn.focus({ preventScroll: true }); } catch (e) {}
  }
  function clearAddFail(btn) { var host = btn && (btn.closest(ADDERR_HOST) || btn.parentNode); var old = host && host.querySelector('.rw-adderr'); if (old) old.remove(); }

  /* W10-1c (A11y W10-1b r2 t6): de ⓘ-knop staat in het label van de radio — een klik/Enter erop mag de keuze niet wijzigen */
  document.addEventListener('click', function (e) { var tip = e.target.closest('.rw-qs .rw-cvtip, .rw-conds .rw-cvtip'); if (tip) { e.preventDefault(); } });

  /* W10-1b IxD-tip 1: mousedown op een uitverkochte conditiekaart (disabled radio) zou de focus op BODY zetten — binnen de quick-shop-dialoog blijft de focus waar hij is */
  document.addEventListener('mousedown', function (e) { if (e.target.closest && e.target.closest('.rw-qs .rw-condr.is-out')) e.preventDefault(); });

  /* ----------------------------------- "toegevoegd aan winkelwagen" popup */
  var addedTimer;
  function escHtml(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function moneyEuro(v) {
    var cents = (typeof v === 'string') ? Math.round(parseFloat(v) * 100) : v;   // cart.js = centen (int); /cart/add = hele euro's (string)
    if (cents == null || isNaN(cents)) return '';
    var s = (cents / 100).toFixed(2).replace('.', ','); return '&euro;' + s; /* W6-3 gate-tip: zelfde notatie als Liquid money ("€9,95") — geen spatie, altijd 2 decimalen */
  }
  function showAdded(line, cart) {
    if (!line) return;
    if (window.matchMedia && window.matchMedia('(max-width: 1024px)').matches) return;   // alleen desktop, niet op telefoon/tablet
    var el = document.getElementById('rw-added-popup');
    if (!el) { el = document.createElement('div'); el.id = 'rw-added-popup'; el.hidden = true; document.body.appendChild(el); }
    var img = line.image || (line.featured_image && line.featured_image.url) || '';
    var vt = (line.variant_title && line.variant_title !== 'Default Title') ? line.variant_title : '';
    var price = (line.final_price != null ? line.final_price : line.price);
    var n = cart ? cart.item_count : null;
    el.innerHTML =
      '<div class="rw-added__ov">' +
        '<div class="rw-added__box" role="status" aria-live="polite" aria-label="Toegevoegd aan je winkelwagen">' +
          '<div class="rw-added__check"><svg viewBox="0 0 24 24" width="33" height="33" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path class="rw-added__tick" d="M5 13l4 4 10-12"/></svg></div>' +
          '<div class="rw-added__h">Toegevoegd aan je winkelwagen!</div>' +
          '<div class="rw-added__prod">' +
            (img ? '<img class="rw-added__img" src="' + escHtml(img) + '" alt="" width="56" height="56" loading="lazy">' : '') +
            '<div class="rw-added__pi">' +
              '<div class="rw-added__pt">' + escHtml(line.product_title || line.title) + '</div>' +
              (vt ? '<div class="rw-added__pv">' + escHtml(vt) + '</div>' : '') +
              '<div class="rw-added__pp">' + moneyEuro(price) + '</div>' +
            '</div>' +
          '</div>' +
          (n != null ? '<div class="rw-added__count">' + n + (n === 1 ? ' artikel' : ' artikelen') + ' in je winkelwagen</div>' : '') +
        '</div>' +
      '</div>';
    el.hidden = false;
    el.classList.remove('is-leaving');
    clearTimeout(addedTimer);
    addedTimer = setTimeout(closeAdded, 1300);   // ~1,5 seconde zichtbaar (1300ms + 220ms fade), ook bij hover (geen pauze)
  }
  function closeAdded() {
    var el = document.getElementById('rw-added-popup');
    if (!el || el.hidden || el.classList.contains('is-leaving')) return;
    clearTimeout(addedTimer);
    el.classList.add('is-leaving');
    setTimeout(function () { el.hidden = true; el.innerHTML = ''; el.classList.remove('is-leaving'); }, 220);
  }

  /* aangevinkte "meebestellen"-items op de PDP (snippets/rw-pdp-addon.liquid) — live-drift 28-08 */
  function addonLines() {
    var lines = [];
    $$('[data-rw-addon-panel] [data-rw-addon-check]').forEach(function (cb) {
      if (!cb.checked) return;
      var vid = parseInt(cb.getAttribute('data-vid'), 10);
      if (vid) lines.push({ id: vid, quantity: 1 });
    });
    return lines;
  }

  function initAddForms() {
    /* RW-C01 (GA4-nalopen 29-09-2026): capture op window en stopPropagation. Shopify hangt zelf een submit-listener aan
       form[action="/cart/add"] en telt daarna ook de fetch hieronder; zonder dit 2x add_to_cart per klik. */
    window.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-rw-add-form]');
      if (!form) return;
      e.stopPropagation();
      e.preventDefault();
      var id = form.querySelector('[name="id"]');
      if (!id || !id.value) return;
      var btn = form.querySelector('[type="submit"]');
      if (btn && btn.getAttribute('aria-busy') === 'true') return; // geen dubbele POST tijdens het toevoegen
      if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); clearAddFail(btn); } // W6-5 IxD r3: bezig-staat ook programmatisch (quick-shop had 'm al)
      var lines = [{ id: parseInt(id.value, 10), quantity: 1 }].concat(addonLines());
      addToCart(lines).then(function () {
        if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
      }).catch(function (err) { if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); } addFail(btn, err); });
    }, true);
    // data-rw-add buttons (cards / quick-shop) carrying a variant id
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-rw-add]');
      if (!b) return;
      e.preventDefault();
      if (b.getAttribute('aria-busy') === 'true') return;
      b.classList.add('is-loading');
      b.setAttribute('aria-busy', 'true'); // W6-5 IxD r2-tip: bezig-staat ook voor AT
      clearAddFail(b);
      // de sticky koopbalk hoort bij het hoofdproduct: aangevinkte add-ons gaan mee.
      // Kaarten en quick-shop niet: die verkopen een ander product dan de PDP.
      var lines = [{ id: parseInt(b.getAttribute('data-rw-add'), 10), quantity: 1 }];
      if (b.closest('[data-rw-stickybar]')) lines = lines.concat(addonLines());
      addToCart(lines).then(function () {
        b.classList.remove('is-loading'); b.removeAttribute('aria-busy');
      }).catch(function (err) { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); addFail(b, err); });
    });
  }

  /* --------------------------------------------------- predictive search
     Section Rendering API: /search/suggest?...&section_id=predictive-search
     (server-rendered products + query suggestions + collections). Debounced + cached. */
  var predictiveCache = {};
  var SEARCH_CORE = (window.RewaySearchConfig || {}).v2 === false ? null : window.RewaySearch;
  /* W7-2 r3 (E-com B4): afkortingen -> winkel-woordenschat, gespiegeld van RewayVerkopen (SH-17) */
  var RW_SYN = {
    ps1: 'playstation 1', psx: 'playstation 1', psone: 'playstation 1',
    ps2: 'playstation 2', ps3: 'playstation 3', ps4: 'playstation 4', ps5: 'playstation 5',
    playstation1: 'playstation 1', playstation2: 'playstation 2', playstation3: 'playstation 3',
    playstation4: 'playstation 4', playstation5: 'playstation 5',
    psvita: 'ps vita', vita: 'ps vita',
    xbox360: 'xbox 360', x360: 'xbox 360',
    xboxone: 'xbox one', xbone: 'xbox one', xb1: 'xbox one', xbox1: 'xbox one',
    xboxseriesx: 'xbox series x', xsx: 'xbox series x',
    wiiu: 'wii u', nintendoswitch: 'nintendo switch',
    gameboy: 'game boy', gba: 'game boy advance', gbc: 'game boy color',
    n64: 'nintendo 64', ngc: 'gamecube', gcn: 'gamecube', nds: 'ds', mk8: 'mario kart 8', gta: 'grand theft auto'
  };
  function rwSynExpand(q) {
    if (SEARCH_CORE) return SEARCH_CORE.expand(q);
    return q.replace(/"/g, ' ').trim().split(/\s+/).filter(Boolean)
      .map(function (w) { return RW_SYN[w.toLowerCase()] || w; }).join(' ');
  }
  /* W7-2 gate r5 (E-com B1): search-fix.js leest window.rwSyn/rwSynExpand voor de resultatenpagina;
     zonder deze export doet /search niets met synoniemen (gta/ps5/...) en belooft de predictive
     producten die na Enter onvindbaar zijn. */
  window.rwSyn = RW_SYN; window.rwSynExpand = rwSynExpand;
  function initPredictiveSearch() {
    $$('[data-rw-search]').forEach(function (root, rootIdx) {
      var input = $('[data-rw-predictive]', root);
      var results = $('[data-rw-predictive-results]', root);
      var clear = $('[data-rw-search-clear]', root);
      if (!input || !results) return;
      var timer, ctrl, requestTimer, requestSeq = 0, lastQ = '', escSuppress = false;
      if (!results.id) results.id = 'rw-ps-results-' + rootIdx;
      input.setAttribute('aria-controls', results.id);
      /* W7-2 gate r3 (A11y B3): expliciete state-semantiek — combobox met dialoog-popup (APG-patroon;
         pijl-omlaag verplaatst de focus het paneel in, dus popup-type dialog, geen listbox). */
      input.setAttribute('role', 'combobox');
      input.setAttribute('aria-haspopup', 'dialog');
      input.setAttribute('aria-expanded', 'false');
      results.setAttribute('role', 'dialog');
      if (!results.getAttribute('aria-label')) results.setAttribute('aria-label', 'Zoeksuggesties');
      function setExpanded() { input.setAttribute('aria-expanded', String(!results.hidden)); }
      /* W7-2 (A11y-gate): schermlezer-feedback - visueel verborgen statusregio per zoekveld */
      var status = document.createElement('div');
      status.className = 'visually-hidden'; status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite');
      root.appendChild(status);
      var busyT;
      function cancelPending() {
        requestSeq += 1;
        clearTimeout(timer); timer = null;
        clearTimeout(requestTimer); requestTimer = null;
        if (ctrl) ctrl.abort();
        ctrl = null;
      }
      function hide() { cancelPending(); results.hidden = true; status.textContent = ''; setLoading(false); setExpanded(); }
      var searchOverlay = root.closest('.rw-search-ov');
      if (searchOverlay) searchOverlay.addEventListener('rw:search-dismiss', hide);
      window.addEventListener('pagehide', hide);
      /* W10-1c (Impatient W7-2 r5): desktop — focus op een leeg veld toont dezelfde snelroutes als de mobiele overlay */
      function quickPanel() {
        if (input.value.trim() !== '' || !window.matchMedia('(min-width: 1024px)').matches) return false;
        var links = Array.prototype.slice.call(document.querySelectorAll('.rw-catbar__item > a.rw-catbar__link')).filter(function (a) { return a.textContent.trim() && !a.closest('.rw-vt-kamer') && a.getAttribute('href') && a.getAttribute('href').indexOf('/collections/') === 0; }).slice(0, 8);
        if (!links.length) return false;
        results.innerHTML = '<div class="rw-ps rw-ps--quick"><div class="rw-ps__quickh">Populaire categorie\u00ebn</div><div class="rw-ps__chips">' + links.map(function (a) { return '<a class="rw-ps__chip" href="' + a.getAttribute('href') + '">' + escHtml(a.textContent.trim()) + '</a>'; }).join('') + '</div></div>';
        results.hidden = false; setExpanded();
        return true;
      }
      input.addEventListener('focus', function () { if (results.hidden && !input.value.trim()) quickPanel(); });
      function setLoading(on) {
        root.classList.toggle('is-searching', !!on); /* W7-2: zichtbare laad-feedback (spinner in de pill) */
        /* W7-2 gate r2 (A11y-tip 3): ook niet-visueel — aria-busy + statusmelding bij trage fetch */
        if (on) { results.setAttribute('aria-busy', 'true'); clearTimeout(busyT); busyT = setTimeout(function () { if (root.classList.contains('is-searching')) status.textContent = 'Zoeken…'; }, 500); }
        else { results.removeAttribute('aria-busy'); clearTimeout(busyT); }
      }
      function show(html, q) {
        results.innerHTML = html; lastQ = q; results.hidden = !html; setLoading(false); setExpanded();
        /* Canonieke zoektermen delen de cache (bijv. ps5/playstation 5), maar de CTA
           moet altijd de tekst bevatten die deze bezoeker daadwerkelijk invoerde. */
        var rawAll = results.querySelector('[data-ps-all]');
        if (rawAll && q) {
          rawAll.setAttribute('href', (routes.search || '/search') + '?q=' + encodeURIComponent(q) + '&type=product');
          rawAll.textContent = 'Alle resultaten voor “' + q + '” →';
        }
        /* W7-2 gate r3 (E-com B2): de 0-staat is geen dead-end — de volledige zoekpagina matcht vaak wél
           (bv. typo's); geef altijd de route naar alle resultaten met de RUWE zoekterm. */
        if (html && q && results.querySelector('.rw-ps--empty') && !results.querySelector('.rw-ps__all')) {
          var allA = document.createElement('a');
          allA.className = 'rw-ps__all';
          allA.href = (routes.search || '/search') + '?q=' + encodeURIComponent(q) + '&type=product';
          allA.textContent = 'Alle resultaten voor “' + q + '” →';
          (results.querySelector('.rw-ps') || results).appendChild(allA);
        }
        bindRows();
        if (html && !root.closest('.rw-search-ov')) {
          /* W7-2 r3 (E-com B5-spiegel): paneel blijft binnen de viewport, met interne scroll */
          var rr = results.getBoundingClientRect();
          results.style.maxHeight = Math.max(200, window.innerHeight - rr.top - 16) + 'px';
        }
        if (html) { var n = results.querySelectorAll('.rw-ps__row').length; status.textContent = results.querySelector('.rw-ps--empty') ? 'Geen exacte treffers' : (n + ' suggesties, gebruik pijl omlaag'); }
      }
      function bindRows() {
        /* W7-2 gate r5 (Impatient-tip 8): dubbele suggesties (zelfde URL) kosten een slot */
        var seenU = {};
        results.querySelectorAll('[data-ps-url]').forEach(function (a) {
          var u = (a.getAttribute('data-ps-url') || '').split('?')[0]; /* W7-2 gate r6: zelfde bestemming met tracking-params is een dubbele rij */
          if (seenU[u]) { (a.closest('.rw-ps__prow') || a).remove(); } else { seenU[u] = 1; }
        });
        var rows = results.querySelectorAll('.rw-ps__row, .rw-ps__all, .rw-ps__chip');
        results.querySelectorAll('[data-ps-url], .rw-ps__all').forEach(function (a) {
          a.addEventListener('mousedown', function (e) { e.preventDefault(); window.location.href = a.getAttribute('href'); });
        });
        return rows;
      }
      var scope = root.getAttribute('data-rw-scope') || '';   // in-collectie zoek-scope (tag:"..."), leeg = globaal
      function markPredictiveEmpty(ps, parsed) {
        if (!ps || ps.querySelector('.rw-ps__row')) return;
        ps.classList.add('rw-ps--empty');
        var all = ps.querySelector('.rw-ps__all');
        if (!ps.querySelector('.rw-ps__none')) {
          var none = ps.ownerDocument.createElement('div');
          none.className = 'rw-ps__none';
          none.textContent = 'Geen exacte treffers voor \u201c' + ((parsed && parsed.raw) || '') + '\u201d.';
          ps.insertBefore(none, all);
        }
        if (!ps.querySelector('.rw-ps__hint')) {
          var hint = ps.ownerDocument.createElement('div');
          hint.className = 'rw-ps__hint';
          hint.innerHTML = 'Probeer een kortere of andere zoekterm, of <a href="/collections">bekijk alle categorie\u00ebn</a>.';
          ps.insertBefore(hint, all);
        }
      }
      function rankPredictive(ps, parsed) {
        if (!SEARCH_CORE || !ps || !parsed) return;
        var group = ps.querySelector('[data-rw-ps-products]');
        var rows = Array.prototype.slice.call((group || ps).querySelectorAll('.rw-ps__prow'));
        if (!rows.length) {
          if (group && group.parentNode) group.parentNode.removeChild(group);
          markPredictiveEmpty(ps, parsed);
          return;
        }
        var kept = rows.map(function (row) {
          var rec = SEARCH_CORE.record(row);
          return { row: row, rec: rec, score: SEARCH_CORE.score(parsed, rec) };
        }).filter(function (x) { return SEARCH_CORE.matches(parsed, x.rec); })
          .sort(function (a, b) { return b.score - a.score; });
        group = group || (rows[0].closest && rows[0].closest('.rw-ps__group'));
        rows.forEach(function (row) { if (row.parentNode) row.parentNode.removeChild(row); });
        if (!kept.length) {
          if (group && group.parentNode) group.parentNode.removeChild(group);
          markPredictiveEmpty(ps, parsed);
          return;
        }
        var parent = group || ps;
        kept.forEach(function (x) { parent.appendChild(x.row); });
      }
      function run(q) {
        cancelPending();
        var seq = requestSeq;
        var parsed = SEARCH_CORE ? SEARCH_CORE.parse(q) : null;
        var xq = parsed ? parsed.apiQuery : rwSynExpand(q); /* één parser voor predictive + resultaten */
        var fq = scope ? (xq + ' ' + scope) : xq;
        var priceKey = parsed && parsed.price ? '|price:' + (parsed.price.min == null ? '' : parsed.price.min) + '-' + (parsed.price.max == null ? '' : parsed.price.max) : '';
        var key = (scope ? scope + '|' : '') + fq.toLowerCase() + priceKey;
        if (predictiveCache[key] != null) {
          if (seq === requestSeq && input.value.trim() === q) show(predictiveCache[key], q);
          return;
        }
        var requestCtrl = new AbortController();
        ctrl = requestCtrl;
        var deadlineTimer, timedOut = false;
        var deadline = new Promise(function (resolve, reject) {
          requestTimer = deadlineTimer = setTimeout(function () {
            timedOut = true;
            requestCtrl.abort();
            reject(new Error('Predictive search timed out'));
          }, 4000);
        });
        setLoading(true);
        var url = routes.predictiveSearch + '?q=' + encodeURIComponent(fq) +
          '&section_id=predictive-search' +
          '&resources[type]=product,collection&resources[limit]=6' +
          '&resources[options][unavailable_products]=hide';
        var response = fetch(url, { signal: requestCtrl.signal })
          /* W7-2 gate r3 (E-com B1): een 429/5xx is een FOUT, geen lege uitslag — anders wordt een
             tijdelijke throttle een onware "geen resultaten" (en vergiftigt hij de cache). */
          .then(function (r) { if (!r.ok) { var e = new Error('suggest ' + r.status); e.rwHttp = r.status; throw e; } return r.text(); });
        Promise.race([response, deadline])
          .then(function (html) {
            if (seq !== requestSeq || input.value.trim() !== q) return;
            // The endpoint returns a full section wrapper; extract the inner .rw-ps if present
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var ps = doc.querySelector('.rw-ps');
            rankPredictive(ps, parsed);
            var allLink = ps && ps.querySelector('[data-ps-all]');
            if (allLink) allLink.setAttribute('href', (routes.search || '/search') + '?q=' + encodeURIComponent(q) + '&type=product');
            var out = ps ? ps.outerHTML : '';
            predictiveCache[key] = out;
            show(out, q);
          })
          .catch(function (err) {
            if ((err && err.name === 'AbortError' && !timedOut) || seq !== requestSeq || input.value.trim() !== q) return;
            /* W7-2 r3 (Mobile-tip 6): offline/fout is geen stille terugval naar de lege staat */
            setLoading(false);
            lastQ = '';
            var errHint = timedOut ? 'Zoeken duurde te lang. Probeer het opnieuw, of bekijk <a href="' + (routes.search || '/search') + '?q=' + encodeURIComponent(q) + '&type=product">alle resultaten</a>.' : (err && err.rwHttp ? 'Even te druk &mdash; probeer het zo opnieuw, of bekijk <a href="' + (routes.search || '/search') + '?q=' + encodeURIComponent(q) + '&type=product">alle resultaten</a>.' : 'Controleer je verbinding en probeer het opnieuw.');
            results.innerHTML = '<div class="rw-ps rw-ps--empty"><div class="rw-ps__none">Zoeken lukte even niet.</div><div class="rw-ps__hint">' + errHint + '</div><button type="button" class="rw-ps__retry" data-rw-ps-retry>Opnieuw proberen</button></div>';
            results.hidden = false; setExpanded();
            /* W7-2 gate r4 (E-com/Impatient-tip): de belofte "probeer het zo opnieuw" krijgt een echte knop */
            var rb = results.querySelector('[data-rw-ps-retry]'); if (rb) rb.addEventListener('click', function () { try { input.focus({ preventScroll: true }); } catch (e2) {} status.textContent = ''; run(q); }); /* W7-2 gate r5 (A11y B3/tip 6): focus niet naar body + nieuwe telling wordt aangekondigd */
            status.textContent = 'Zoeken lukte even niet';
          }).finally(function () {
            clearTimeout(deadlineTimer);
            if (requestTimer === deadlineTimer) requestTimer = null;
            if (ctrl === requestCtrl) ctrl = null;
          });
      }
      input.setAttribute('autocomplete', 'off');
      input.addEventListener('input', function () {
        var q = input.value.trim();
        if (clear) clear.hidden = !q;
        cancelPending();
        setLoading(false);
        if (q.length < 2) {
          hide();
          return;
        }
        timer = setTimeout(function () { timer = null; run(q); }, 200);
      });
      input.addEventListener('focus', function () {
        if (escSuppress) return; /* W7-2: focus-terugkeer na Escape mag het paneel niet heropenen */
        var q = input.value.trim();
        if (q.length >= 2 && q === lastQ && results.innerHTML) { results.hidden = false; setExpanded(); }
        else if (q.length >= 2 && !ctrl && !timer) timer = setTimeout(function () { timer = null; run(q); }, 200);
      });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          /* W7-2 r3 (Mobile B2): in de fullscreen overlay is er geen aparte dropdown — 1 Escape sluit
             de hele dialoog (paneel dicht + laten bubbelen naar de overlay-sluiter).
             Desktop blijft gelaagd: 1e Escape alleen het paneel (geen native wissen), 2e wist/sluit. */
          if (root.closest('.rw-search-ov')) { hide(); }
          else if (!results.hidden || ctrl || timer) { e.preventDefault(); e.stopPropagation(); hide(); }
        }
        else if (e.key === 'ArrowDown' && !results.hidden) {
          var first = results.querySelector('.rw-ps__row, .rw-ps__chip');
          if (first) { e.preventDefault(); first.focus(); }
        }
        else if (e.key === 'ArrowDown' && results.hidden && root.closest('.rw-search-ov')) {
          /* W10-1c gate r4 (A11y tip 3): in de overlay gaat pijl-omlaag vanuit het lege veld naar de eerste snelroute-chip */
          var ovc = root.closest('.rw-search-ov').querySelector('.rw-search-ov__chip');
          if (ovc) { e.preventDefault(); ovc.focus(); }
        }
        else if (e.key === 'Enter') {
          /* Enter → altijd naar de volledige zoekresultatenpagina (laat het formulier submitten), niet naar het eerste resultaat */
          hide();
        }
      });
      /* W10-1c gate r4 (A11y tip 3): overlay-chips "Populaire categorieën" met dezelfde toetsgrammatica als de desktop-snelroutes */
      (function () {
        var ov = root.closest('.rw-search-ov'); var wrap = ov && ov.querySelector('.rw-search-ov__chips'); if (!wrap) return;
        wrap.addEventListener('keydown', function (e) {
          var chips = Array.prototype.slice.call(wrap.querySelectorAll('.rw-search-ov__chip')); var i = chips.indexOf(document.activeElement); if (i === -1) return;
          var to = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') to = chips[i + 1] || null;
          else if (e.key === 'ArrowLeft') to = chips[i - 1] || null;
          else if (e.key === 'Home') to = chips[0];
          else if (e.key === 'End') to = chips[chips.length - 1];
          else if (e.key === 'ArrowUp') { e.preventDefault(); input.focus(); return; }
          else return;
          if (to) { e.preventDefault(); to.focus(); }
        });
      })();
      /* W7-2: pijltjes-navigatie dóór de resultaten (spiegel van RewayVerkopen) — Escape terug naar het veld */
      results.addEventListener('keydown', function (e) {
        var rows = Array.prototype.slice.call(results.querySelectorAll('.rw-ps__row, .rw-ps__all, .rw-ps__chip'));
        var idx = rows.indexOf(document.activeElement);
        if (idx === -1) {
          /* W7-2 gate r4 (E-com B1): focus op een niet-rij-element in het paneel (bv. de quick-shop-knop
             na focus-terugkeer) — Escape sluit dan alsnog het paneel */
          if (e.key === 'Escape' && results.contains(document.activeElement)) {
            if (root.closest('.rw-search-ov')) { hide(); }
            else { e.preventDefault(); e.stopPropagation(); escSuppress = true; hide(); input.focus(); escSuppress = false; }
          }
          return;
        }
        if (e.key === 'ArrowDown') { e.preventDefault(); (rows[idx + 1] || rows[0]).focus(); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); if (idx === 0) { input.focus(); } else { rows[idx - 1].focus(); } }
        else if ((e.key === 'Home' || e.key === 'End') && rows[idx].classList.contains('rw-ps__chip')) {
          e.preventDefault(); var chipsOnly = rows.filter(function (r) { return r.classList.contains('rw-ps__chip'); }); (e.key === 'Home' ? chipsOnly[0] : chipsOnly[chipsOnly.length - 1]).focus();
        }
        else if ((e.key === 'ArrowRight' || e.key === 'ArrowLeft') && rows[idx].classList.contains('rw-ps__chip')) {
          /* A11y r2 tip 2: links/rechts binnen de chiprij (snelroutes), zonder wrap — boven/onder blijft de rijnavigatie */
          var nb = rows[idx + (e.key === 'ArrowRight' ? 1 : -1)];
          if (nb && nb.classList.contains('rw-ps__chip')) { e.preventDefault(); nb.focus(); }
        }
        else if (e.key === 'Escape') {
          if (root.closest('.rw-search-ov')) { hide(); } /* overlay: laten bubbelen — dialoog sluit in dezelfde druk */
          else { e.preventDefault(); e.stopPropagation(); escSuppress = true; hide(); input.focus(); escSuppress = false; }
        }
      });
      document.addEventListener('click', function (e) {
        if (root.contains(e.target)) return;
        if (!document.contains(e.target)) return; /* target al verwijderd — geen oordeel mogelijk */
        if (e.target.closest && e.target.closest('[data-rw-quickshop], #rw-qs, #rw-qs-added')) return; /* W7-2 r3: klik ín de quick-shop hoort bij de zoekflow */
        hide();
      });
      /* W7-2 gate r2 (A11y B1): paneel sluit zodra de focus het zoekwidget verlaat (Tab-weg) en op
         Escape terwijl de focus al buiten staat — geen open paneel meer bóven de focusroute. */
      root.addEventListener('focusout', function (e) {
        if (!e.relatedTarget || root.contains(e.relatedTarget)) return;
        if (e.relatedTarget.closest && e.relatedTarget.closest('[data-rw-quickshop], #rw-qs, #rw-qs-added')) return; /* quick-shop hoort bij de zoekflow */
        hide();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape' || results.hidden || root.contains(document.activeElement)) return;
        /* W7-2 gate r3 (A11y B1): staat de focus in de quick-shop (geopend vanuit een suggestierij),
           dan hoort deze Escape bij DIE laag — het paneel eronder blijft staan (1 druk = 1 laag). */
        var ae = document.activeElement;
        if (ae && ae.closest && ae.closest('[data-rw-quickshop], #rw-qs, #rw-qs-added')) return;
        hide();
      });
      var sform = root.querySelector('form');
      if (sform) sform.addEventListener('submit', function (e) { if (!input.value.trim()) { e.preventDefault(); input.focus(); } }); /* leeg veld: geen lege resultatenpagina */
      if (clear) clear.addEventListener('click', function () { input.value = ''; clear.hidden = true; hide(); input.focus(); });
      /* W7-2 r3 (Impatient B5): wie al typte voordat de JS geladen was, krijgt alsnog direct suggesties */
      if (document.activeElement === input && input.value.trim().length >= 2) run(input.value.trim());
    });
    /* W7-2 r3 (Impatient-tip 5): '/' focust zoeken (power-user), zoals GitHub/YouTube */
    document.addEventListener('keydown', function (e) {
      if (e.key !== '/' || e.ctrlKey || e.metaKey || e.altKey) return;
      var t = e.target;
      if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.tagName === 'SELECT' || t.isContentEditable)) return;
      var inp = Array.prototype.find.call(document.querySelectorAll('[data-rw-search] input[type="search"]'), function (el) { return el.getClientRects().length > 0; });
      if (inp) { e.preventDefault(); inp.focus(); }
      else if (window.rwOpenSearchOv) { e.preventDefault(); window.rwOpenSearchOv(); }
    });
  }

  /* ------------------------------------------------------- quick-shop */
  var QuickShop = null;
  function initQuickShop() {
    var modal = $('[data-rw-quickshop]');
    if (!modal) return;
    var body = $('[data-rw-qs-body]', modal);
    var qsSeq = 0, qsLoad = null, qsResume = null;
    function finishLoad(load) {
      clearTimeout(load.timer);
      if (qsLoad === load) qsLoad = null;
    }
    function cancelLoad() {
      qsSeq++;
      if (!qsLoad) return;
      var load = qsLoad;
      finishLoad(load);
      if (load.ctrl) load.ctrl.abort();
    }
    function open() {
      if (!modal.hidden) return; modal.hidden = false; modal.removeAttribute('aria-hidden'); rwLayerPush(); lockScroll(true);
      rwDialogOpen(modal, { initial: 'button[data-rw-qs-close]' }); /* de overlay-div draagt hetzelfde attribuut en is niet focusbaar */
      /* W7-2 gate r5 (Mobile B1): trigger is al vastgelegd — blur het zoekveld direct, anders houdt
         Android het toetsenbord open en bedekt het de conditielijst + CTA van de sheet. */
      var aeQ = document.activeElement;
      if (aeQ && aeQ !== document.body && !modal.contains(aeQ) && aeQ.blur) { try { aeQ.blur(); } catch (eB) {} }
    }
    function close() { cancelLoad(); if (modal.hidden) return; modal.hidden = true; modal.setAttribute('aria-hidden', 'true') /* W7-2 gate r3 (A11y B2): dialoog ook expliciet uit de accessibility tree, onafhankelijk van CSS */; rwLayerPop(); lockScroll(false); body.innerHTML = '<div class="rw-qs__loading">…</div>'; rwDialogClose(modal); }
    /* W7-2 gate r3 (Mobile B1): Android-terugknop sluit eerst de bovenste laag (deze sheet), niet de overlay eronder */
    window.rwQuickShopBackClose = function () { if (modal.hidden) return false; close(); return true; };
    // soft-hide: dismiss the quick-shop after add-to-cart so the cart drawer becomes the visible popup.
    // De quick-shop liet zijn eigen scroll-lock vrij (ref-counted): de drawer neemt daarna een eigen lock,
    // zodat sluiten van de drawer de pagina weer volledig ontgrendelt (anders blijft overflow:hidden hangen).
    QuickShop = { hide: function () { cancelLoad(); if (modal.hidden) return; modal.hidden = true; modal.setAttribute('aria-hidden', 'true'); body.innerHTML = '<div class="rw-qs__loading">…</div>'; lockScroll(false); rwDialogClose(modal); } };
    window.addEventListener('pagehide', function () { qsResume = qsLoad && !qsLoad.rendered && !modal.hidden ? qsLoad.handle : null; cancelLoad(); });
    window.addEventListener('pageshow', function (e) { var handle = qsResume; qsResume = null; if (e.persisted && handle && !modal.hidden) loadHandle(handle); });
    modal.addEventListener('click', function (e) {
      // W6-5 Mobile-gate: de ⓘ zit in het label — uitleg vragen mag nooit tegelijk de conditie kiezen
      if (e.target.closest('.rw-cvtip')) { e.preventDefault(); var tip = e.target.closest('.rw-cvtip'); try { tip.focus(); } catch (e2) {} return; }
      if (e.target.closest('[data-rw-qs-close]') || e.target.matches('.rw-qs__overlay')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || modal.hidden) return;
      if (window.rwDialogTop && window.rwDialogTop() !== modal) return; // W7-1: alleen de bovenste dialoog reageert op Escape
      // W6-5 IxD r3: Escape sluit het bovenste element - een open conditie-tooltip eerst (de cvtip-handler doet dat), pas daarna de dialog
      if (e.rwTipDismissed || modal.querySelector('.rw-cvtip:focus, .rw-cvtip:hover:not(.is-off)')) return; // de cvtip-handler draait eerder (registratie bij scriptstart) en zet de vlag
      close();
    });
    // W10-1a gate r3 (E-com B1): laden en foutstaat gescheiden van open() — bij een mislukte fragment-load
    // (429/offline/time-out) bleef het venster leeg met alleen "—" en Sluiten. Nu: skeleton tijdens het laden,
    // en bij een fout een melding met "Opnieuw proberen" + "Naar product" (de kaart-URL); geen dubbele scroll-lock bij retry.
    function qsError(handle) {
      body.innerHTML = '<div class="rw-qs__err"><p class="rw-qs__err-txt" role="alert">De opties konden niet worden geladen. Controleer je verbinding of probeer het opnieuw.</p>' +
        '<div class="rw-qs__err-acts"><button type="button" class="rw-btn rw-btn--outline" data-rw-qs-retry="' + handle + '">Opnieuw proberen</button>' +
        '<a class="rw-btn rw-btn--primary" href="' + routes.root + 'products/' + handle + '">Naar product →</a></div></div>';
      var retry = body.querySelector('[data-rw-qs-retry]');
      if (retry && !modal.hidden) { try { retry.focus({ preventScroll: true }); } catch (e4) {} setTimeout(function () { if (!modal.hidden && document.activeElement !== retry && !modal.querySelector('.rw-qs__err') === false && (modal.contains(document.activeElement) === false || document.activeElement.matches('[data-rw-qs-close]'))) { try { retry.focus({ preventScroll: true }); } catch (e5) {} } }, 160); }
    }
    /* W15-2a (FQE B2): een verdwenen product (uniek exemplaar verkocht/gedepubliceerd) geeft een HTTP 200 met een lege sectierender — geen netwerkfout,
       dus geen qsError. Eerlijke staat i.p.v. een spooksheet met 'controleer je verbinding'. */
    function qsGone(handle) {
      var favs = {}; try { favs = JSON.parse(localStorage.getItem('reway_favs') || '{}'); } catch (eF) {}
      var f = favs[handle], title = (f && f.title) ? f.title : '';
      body.innerHTML = '<div class="rw-qs__err"><p class="rw-qs__err-txt" role="alert">Dit product is niet meer beschikbaar' + (title ? ': ' + escHtml(title) : '') + '. Tweedehands artikelen zijn vaak unieke exemplaren.</p>' +
        '<div class="rw-qs__err-acts">' + (title ? '<a class="rw-btn rw-btn--primary" href="' + routes.root + 'search?q=' + encodeURIComponent(title) + '&type=product">Zoek vergelijkbaar &rarr;</a>' : '') +
        (f ? '<button type="button" class="rw-btn rw-btn--outline" data-rw-qs-unfav="' + escHtml(handle) + '">Verwijder uit favorieten</button>' : '') + '</div></div>';
      var un = body.querySelector('[data-rw-qs-unfav]');
      if (un) un.addEventListener('click', function () { try { var o = JSON.parse(localStorage.getItem('reway_favs') || '{}'); delete o[handle]; localStorage.setItem('reway_favs', JSON.stringify(o)); } catch (eU) {} if (typeof window.RewayFavRender === 'function') window.RewayFavRender(); if (QuickShop) QuickShop.hide(); });
      var f1 = body.querySelector('a, button'); if (f1 && !modal.hidden) { try { f1.focus({ preventScroll: true }); } catch (e5) {} }
    }
    function loadHandle(handle) {
      cancelLoad();
      var seq = qsSeq;
      body.innerHTML = '<div class="rw-qs__loading" aria-busy="true"><span class="rw-qs__skel rw-qs__skel--img"></span><span class="rw-qs__skel rw-qs__skel--l1"></span><span class="rw-qs__skel rw-qs__skel--l2"></span><span class="rw-qs__skel rw-qs__skel--btn"></span><span class="visually-hidden">Opties laden…</span></div>';
      var ctrl = (typeof AbortController !== 'undefined') ? new AbortController() : null;
      var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, 8000);
      var load = qsLoad = { ctrl: ctrl, timer: timer, handle: handle, rendered: false };
      // cache-buster: voorkom dat een gecachte (oude) sectie-render geserveerd wordt; quick-shop moet altijd actueel zijn (voorraad/condities)
      var fragment = fetch(routes.root + 'products/' + handle + '?section_id=quick-shop-card&_=' + Date.now(), { cache: 'no-store', signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) { if (!r.ok) throw new Error('qs ' + r.status); return r.text(); })
        .then(function (html) { clearTimeout(timer); return html; });
      return Promise.all([loadProductRuntime(), fragment])
        .then(function (parts) {
          var html = parts[1];
          if (seq !== qsSeq || modal.hidden || !modal.isConnected) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var inner = doc.querySelector('[data-rw-qs-render]');
          if (!inner) { qsError(handle); return; }
          /* W15-2a (FQE B2): sectie gerenderd maar zonder product (onbekende handle) -> eigen staat */
          var vBlob = inner.querySelector('[data-rw-variants]'), vList = null; try { vList = vBlob ? JSON.parse(vBlob.textContent) : null; } catch (eB) { vList = null; }
          var tEl = inner.querySelector('.rw-qs__title');
          if ((!vList || !vList.length) && !(tEl && tEl.textContent.trim())) { qsGone(handle); return; }
          load.rendered = true;
          body.innerHTML = inner.innerHTML;
          var qsTitle = body.querySelector('.rw-qs__title'), qsCard = modal.querySelector('.rw-qs__card'); // W6-5 IxD r5-tip (T4): dialoognaam = zichtbare titel
          if (qsTitle && qsCard) { if (!qsCard.dataset.rwLabel) qsCard.dataset.rwLabel = qsCard.getAttribute('aria-label') || 'Opties kiezen'; qsCard.setAttribute('aria-label', qsCard.dataset.rwLabel + ': ' + qsTitle.textContent.trim()); }
          /* W10-1c (IxD W10-1b t2): staat dit product al in het mandje, dan zegt de sheet dat (spiegel verkoop-quick-sell) */
          var cartCheck = (function () {
            var vjs = body.querySelector('[data-rw-variants]');
            if (!vjs) return;
            var vids = [];
            try { vids = JSON.parse(vjs.textContent).map(function (v) { return String(v.id); }); } catch (eV) { return; }
            return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, signal: ctrl ? ctrl.signal : undefined }).then(function (r) { return r.ok ? r.json() : null; }).then(function (c) {
              if (!c || modal.hidden || !modal.isConnected || seq !== qsSeq) return;
              var inC = (c.items || []).filter(function (it) { return vids.indexOf(String(it.variant_id)) > -1; });
              if (!inC.length) return;
              var n = inC.reduce(function (a, it) { return a + it.quantity; }, 0);
              var host = body.querySelector('.rw-qs__details');
              if (host && !host.querySelector('.rw-qs__incart')) {
                var note = document.createElement('div'); note.className = 'rw-qs__incart'; note.setAttribute('role', 'note');
                note.innerHTML = 'Zit al ' + (n > 1 ? n + '\u00d7 ' : '') + 'in je winkelwagen \u00b7 <a href="' + (routes.cart || '/cart') + '">bekijk mandje</a>';
                var pr = host.querySelector('.rw-qs__pricerow'); if (pr && pr.nextSibling) host.insertBefore(note, pr.nextSibling); else host.appendChild(note);
              }
            }).catch(function () {});
          })();
          var firstChoice = body.querySelector('input[type="radio"]:checked, input[type="radio"], [data-rw-addbtn]');
          /* W7-2 gate r5 (Mobile B1): zolang de sheet open is neemt hij de focus — de oude
             modal.contains(activeElement)-guard faalde precies wanneer de 40ms-initialfocus niet
             gelukt was (zoekveld hield focus + toetsenbord). */
          if (firstChoice && !modal.hidden) { try { firstChoice.focus({ preventScroll: true }); } catch (e3) {} }
          return cartCheck;
        }).catch(function () { if (ctrl) ctrl.abort(); if (seq === qsSeq && !modal.hidden && modal.isConnected) qsError(handle); })
        .then(function () { finishLoad(load); });
    }
    function openHandle(handle) {
      open();
      return loadHandle(handle);
    }
    modal.addEventListener('click', function (e) {
      var rt = e.target.closest('[data-rw-qs-retry]');
      if (rt) { e.preventDefault(); loadHandle(rt.getAttribute('data-rw-qs-retry')); }
    });
    document.addEventListener('click', function (e) {
      var trig = e.target.closest('[data-rw-quickshop-open]');
      if (!trig) return;
      e.preventDefault();
      if (document.activeElement !== trig) { try { trig.focus({ preventScroll: true }); } catch (e2) {} } // focus-return-anker bij muis/touch
      openHandle(trig.getAttribute('data-rw-quickshop-open'));
    });
    // Debug hook: ?rwqs=1 auto-opens the first quick-shop (for screenshots). rwqs=2 also expands sold-out.
    if (location.search.indexOf('rwqs=') !== -1) {
      setTimeout(function () {
        var t = document.querySelector('[data-rw-quickshop-open]');
        if (t) openHandle(t.getAttribute('data-rw-quickshop-open')).then(function () {
          if (location.search.indexOf('rwqs=2') !== -1) {
            setTimeout(function () {
              var more = modal.querySelector('[data-rw-show-soldout]');
              if (more) more.click();
            }, 500);
          }
        });
      }, 400);
    }
  }

  /* ------------------------------------------------------- trust pill */
  function wkEsc(s) { return (s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function wkInitials(name) { var p = (name || '').trim().split(/\s+/); return ((p[0] || '')[0] || '' ) + ((p[1] || '')[0] || ''); }
  function wkDatumNL(d) { var MND = ['januari','februari','maart','april','mei','juni','juli','augustus','september','oktober','november','december']; var p = String(d || '').split('-'); if (p.length === 3 && p[0].length === 4) { var mi = parseInt(p[1], 10) - 1; if (mi >= 0 && mi < 12) return parseInt(p[2], 10) + ' ' + MND[mi] + ' ' + p[0]; } return d || ''; } /* W6-3: '2026-08-25' las als ruwe ISO in het reviewvenster */
  function wkStars(n) { n = Math.max(1, Math.min(5, n || 5)); return '★'.repeat(n) + (n < 5 ? '<span class="rw-wkm__rstars-e">' + '★'.repeat(5 - n) + '</span>' : ''); } /* W15-2c r7 (Visual B6): vijf posities - lege sterren als spoor, zodat 1 van 5 te lezen is i.p.v. te tellen */
  function renderWkReviews() {
    var el = document.getElementById('rw-wk-reviews');
    if (!el) return;
    var wk; try { wk = JSON.parse(el.textContent); } catch (e) { return; }
    var revs = (wk && wk.reviews) || [];
    /* Sjaak 06-09-2026: 1- en 2-sterrenreviews niet op de eigen site tonen (pill + reviewvenster);
       wie ze wil lezen vindt ze volledig op WebwinkelKeur zelf. */
    revs = revs.filter(function (r) { var n = Number(r && r.rating); return !(n >= 1 && n <= 2); });
    // document-breed alle zichtbare aantallen + scores live bijwerken (nette NL-notatie: 5.692)
    if (wk.total) {
      var totalFmt = Number(wk.total).toLocaleString('nl-NL');
      document.querySelectorAll('[data-rw-wk-total]').forEach(function (t) { t.textContent = totalFmt; if (t.hasAttribute('data-count')) t.setAttribute('data-count', totalFmt); });
      /* W10-1c gate (A11y B2, 2.5.3): de openernaam meebewegen met het live-aantal */
      document.querySelectorAll('.rw-topbar__l[data-rw-wk-open][aria-label], .rw-bar__wk[aria-label]').forEach( /* A11y r2 tip 1: ook de header-chip volgt het live-aantal (één getal voor hetzelfde keurmerk) */function (a) { a.setAttribute('aria-label', a.getAttribute('aria-label').replace(/\d[\d.]* beoordelingen/, totalFmt + ' beoordelingen')); });
    }
    if (wk.average) {
      document.querySelectorAll('[data-rw-wk-avg]').forEach(function (a) { a.textContent = wk.average; if (a.hasAttribute('data-count')) a.setAttribute('data-count', wk.average); });
    }
    var pillBox = document.querySelector('[data-rw-wk-reviews-pill]');
    if (pillBox && revs.length) {
      pillBox.innerHTML = revs.slice(0, 5).map(function (r) {
        return '<div class="rw-wk__review"><div class="rw-wk__rtop"><span class="rw-wk__ravatar">' + wkEsc(wkInitials(r.name).toUpperCase()) + '</span><span class="rw-wk__rname">' + wkEsc(r.name) + '</span><span class="rw-wk__stars rw-wk__stars--sm">' + wkStars(r.rating) + '</span></div><p class="rw-wk__rquote">' + wkEsc(r.comment) + '</p></div>';
      }).join('');
    }
    var modalBox = document.querySelector('[data-rw-wk-reviews-modal]');
    if (modalBox && revs.length) {
      modalBox.innerHTML = revs.map(function (r) {
        return '<div class="rw-wkm__review"><div class="rw-wkm__rhead"><span class="rw-wkm__ravatar">' + wkEsc(wkInitials(r.name).toUpperCase()) + '</span><span class="rw-wkm__rmeta"><span class="rw-wkm__rname">' + wkEsc(r.name) + '</span><span class="rw-wkm__rverified">✓ Geverifieerde klant · ' + wkEsc(wkDatumNL(r.date)) + '</span></span><span class="rw-wkm__rstars" role="img" aria-label="' + wkEsc(String(r.rating)) + ' van 5 sterren"><span aria-hidden="true">' + wkStars(r.rating) + '</span></span></div><p class="rw-wkm__rquote">' + wkEsc(r.comment) + '</p></div>';
      }).join('');
    }
  }

  function initTrustPill() {
    renderWkReviews();
    var pill = $('[data-rw-trustpill]');
    if (pill) {
    /* W6-1: footer-onderruimte is alleen pill-parkeerruimte als de pill echt zichtbaar is */
    var setPillRoom = function (on) { document.documentElement.classList.toggle('rw-haspill', on); };
    try { if (sessionStorage.getItem('rw-wk-closed') === '1') { pill.hidden = true; } } catch (e) {}
    setPillRoom(!pill.hidden);
    var closeBtn = $('[data-rw-wk-close]', pill);
    if (closeBtn) closeBtn.addEventListener('click', function () {
      pill.hidden = true;
      setPillRoom(false);
      try { sessionStorage.setItem('rw-wk-closed', '1'); } catch (e) {}
    });
    // drag to reposition (pointer)
    var grip = $('[data-rw-wk-drag]', pill);
    if (grip) {
      var sx, sy, ox, oy, dragging = false;
      grip.addEventListener('pointerdown', function (e) {
        dragging = true; pill.classList.add('is-dragging');
        var r = pill.getBoundingClientRect();
        sx = e.clientX; sy = e.clientY; ox = r.left; oy = r.top;
        grip.setPointerCapture(e.pointerId);
        e.preventDefault();
      });
      grip.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var nx = Math.max(6, Math.min(window.innerWidth - pill.offsetWidth - 6, ox + (e.clientX - sx)));
        var ny = Math.max(6, Math.min(window.innerHeight - pill.offsetHeight - 6, oy + (e.clientY - sy)));
        pill.style.left = nx + 'px';
        pill.style.top = ny + 'px';
        pill.style.bottom = 'auto';
      });
      grip.addEventListener('pointerup', function () { dragging = false; pill.classList.remove('is-dragging'); });
      grip.addEventListener('pointercancel', function () { dragging = false; pill.classList.remove('is-dragging'); });
      /* W6-9 gate (FQE): een versleepte pill blijft na een venster-resize binnen beeld */
      window.addEventListener('resize', function () {
        if (!pill.style.left) return;
        var r = pill.getBoundingClientRect();
        pill.style.left = Math.max(6, Math.min(window.innerWidth - r.width - 6, r.left)) + 'px';
        pill.style.top = Math.max(6, Math.min(window.innerHeight - r.height - 6, r.top)) + 'px';
      });
    }
    /* W6-9: na een schermhoogte scrollen klapt de pill in tot badge + score (minder overlap met grids/PDP);
       hover of focus klapt hem weer uit. Boven de vouw blijft hij volledig. */
    var compactTick = false;
    function pillCompact() {
      compactTick = false;
      if (pill.style.top) return; /* handmatig versleept: laten staan */
      pill.classList.toggle('is-compact', window.scrollY > Math.max(320, window.innerHeight * 0.5));
    }
    window.addEventListener('scroll', function () { if (!compactTick) { compactTick = true; requestAnimationFrame(pillCompact); } }, { passive: true });
    pillCompact();
    /* W6-9 gate (A11y, SC 1.4.13): Escape sluit de hover-popover zonder de muis te verplaatsen */
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && pill.matches(':hover')) pill.classList.add('is-popclosed'); });
    pill.addEventListener('mouseleave', function () { pill.classList.remove('is-popclosed'); });
    }
    // WebwinkelKeur reviews modal (opens on same page)
    var modal = $('[data-rw-wk-modal]');
    if (modal) {
      /* W6-9 (a11y-gate W3-1): focus het venster in, Tab blijft binnen, rest inert, focus terug naar de trigger */
      function wkExpanded(on) { $$('[data-rw-wk-open][aria-haspopup]').forEach(function (b) { b.setAttribute('aria-expanded', on ? 'true' : 'false'); }); } /* W10-1a gate r3 (E-com T-1/A11y r2 T-b): dialoogstaat op de chip */
      function wkOpen(trigger) { if (!modal.hidden) return; modal.hidden = false; lockScroll(true); rwDialogOpen(modal, { initial: '.rw-wkm__close', trigger: trigger }); wkExpanded(true); }
      function wkClose() { if (modal.hidden) return; modal.hidden = true; lockScroll(false); rwDialogClose(modal); wkExpanded(false); }
      $$('[data-rw-wk-open]').forEach(function (b) {
        b.addEventListener('click', function (e) { e.preventDefault(); var t = pill && b.closest('.rw-wk__pop') ? ($('.rw-wk__bar .rw-wk__badge', pill) || b) : b; wkOpen(t); }); /* popover verdwijnt na sluiten: focus-return naar de badge */
      });
      modal.addEventListener('click', function (e) {
        if (e.target.closest('[data-rw-wk-modal-close]') || e.target.matches('.rw-wkm__overlay')) { wkClose(); }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) { wkClose(); } });
      if (location.search.indexOf('rwwk=1') !== -1) { setTimeout(function () { wkOpen(null); }, 300); } /* W6-9 gate (FQE): ook via de shortcut met lock/inert/focus */
    }
  }

  /* ------------------------------------------------- cart page qty steppers */
  /* W6-3 gate (E-com + Mobile r3): de cartpagina gebruikt hetzelfde Ajax-pad als de drawer
     (cart/change.js) i.p.v. een volledige form.submit per klik: bezig-staat per regel, geen
     scroll-reset, voorraad-cap (data-rw-qty-max), inline foutregel bij 422, statusregio voor
     screenreaders en 'Ongedaan maken' na verwijderen. Zonder JS blijft het formulier werken
     (verborgen name="update"-submit = Enter-doel; kruisje = url_to_remove). */
  var cartStatusTimer = null;
  var cartRefocusHint = null; /* W10-1c gate r3 (A11y B1): Enter in het aantal-veld blurt vóór de her-render — de focusbestemming wordt hier vooraf onthouden */
  var cartPageRenderVersion = 0;
  function cartPageStatus(msg) {
    var el = document.querySelector('[data-rw-cart-status]');
    if (!el) return;
    el.textContent = msg || '';
    if (cartStatusTimer) clearTimeout(cartStatusTimer);
    // W6-3 r5 (E-com): verouderde feedback niet laten hangen — na 5 s ruimt de regel zichzelf op
    if (msg) cartStatusTimer = setTimeout(function () { var e2 = document.querySelector('[data-rw-cart-status]'); if (e2 && e2.textContent === msg) e2.textContent = ''; }, 5000);
  }
  var cartToastTimer = null;
  function cartPageToast(msg) {
    var old = document.querySelector('.rw-cart-undo:not(.rw-cart-undo--undo)');
    if (old) old.remove();
    if (cartToastTimer) clearTimeout(cartToastTimer);
    var el = document.createElement('div');
    el.className = 'rw-cart-undo rw-cart-undo--info';
    el.setAttribute('aria-hidden', 'true'); /* W10-1c gate r4 (A11y tip 2): de sr-statusregio meldt al — de toast is alleen het visuele kanaal (geen dubbele aankondiging) */
    el.innerHTML = '<span>' + msg + '</span>';
    document.body.appendChild(el);
    cartToastTimer = setTimeout(function () { el.remove(); }, 3000);
  }
  function cartPageRerender() {
    var renderVersion = ++cartPageRenderVersion;
    var mutationVersion = CartDrawer.mutationVersion;
    var page = document.querySelector('.rw-cartpage');
    var section = page && page.closest('[id^="shopify-section-"]');
    var url = new URL(location.href);
    if (section) url.searchParams.set('section_id', section.id.replace(/^shopify-section-/, ''));
    return CartDrawer.requestData(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } }, true)
      .then(function (html) {
        if (renderVersion !== cartPageRenderVersion || mutationVersion !== CartDrawer.mutationVersion) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        // hele cart-sectie vervangen (niet alleen het formulier) zodat ook de overgang naar de
        // lege staat zonder reload verloopt en de undo-toast blijft staan
        var fresh = doc.querySelector('.rw-cartpage');
        var cur = document.querySelector('.rw-cartpage');
        var y = window.scrollY; // W6-3 r5 (E-com): scrollpositie behouden over de DOM-vervanging
        // W6-5 IxD r3: focus overleeft de DOM-vervanging — zelfde control terugvinden (regel + aria-label), anders de paginakop
        var act = document.activeElement, actRow = act && act.closest ? act.closest('[data-rw-line]') : null;
        var actKey = act && cur && cur.contains(act) ? { line: actRow ? actRow.getAttribute('data-rw-line') : null, key: CartDrawer.itemKey(actRow), label: act.getAttribute('aria-label'), tag: act.tagName, qty: act.getAttribute('data-rw-qty') } : cartRefocusHint; cartRefocusHint = null;
        if (fresh && cur) {
          var keepT = cur.querySelector('.rw-cart-undo--undo'); if (keepT) keepT.remove(); /* W10-1b: toast staat in de DOM na de H1 — meenemen over de vervanging */
          cur.replaceWith(fresh); upsellFill(fresh); window.scrollTo(0, Math.min(y, Math.max(0, document.documentElement.scrollHeight - window.innerHeight)));
          var freshCount = fresh.getAttribute('data-rw-cart-items');
          if (freshCount !== null && /^\d+$/.test(freshCount)) updateCartCount(+freshCount);
          /* W10-1b (E-com W9-2 r5): laatste regel weg → 'Ongedaan maken' verhuist van de toast naar een blijvende regel in de lege staat */
          (function () { var emp = fresh.querySelector('.rw-cartpage__empty'); if (!keepT) return; if (!emp) { var h1k = fresh.querySelector('.rw-cartpage__h1'); if (h1k) h1k.insertAdjacentElement('afterend', keepT); else document.body.appendChild(keepT); return; } var btn = keepT.querySelector('.rw-cart-undo__btn'); if (!btn) return; var ttl = (keepT.querySelector('span') || {}).textContent || ''; ttl = ttl.replace(/^Verwijderd:?\s*/, ''); var wrap = document.createElement('div'); wrap.className = 'rw-emptystate__undo'; wrap.setAttribute('role', 'status'); wrap.innerHTML = '<span>Per ongeluk verwijderd?</span>'; btn.textContent = ttl ? 'Zet \u201c' + ttl + '\u201d terug' : 'Zet het terug'; wrap.appendChild(btn); var ch = emp.querySelector('.rw-emptystate__chips'); emp.insertBefore(wrap, ch || emp.querySelector('.rw-btn')); })();
          if (actKey) {
            var back = null;
            if (actKey.line) {
              var row2 = actKey.key ? CartDrawer.rowForKey(fresh, actKey.key) : fresh.querySelector('[data-rw-line="' + actKey.line + '"]');
              if (row2 && actKey.label) back = Array.prototype.filter.call(row2.querySelectorAll(actKey.tag), function (n) { return n.getAttribute('aria-label') === actKey.label; })[0];
              // dec-knop wisselt van label/icoon zodra qty 1 wordt (minus -> prullenbak) — zelfde knop op positie terugvinden
              if (!back && row2 && actKey.qty) back = row2.querySelector('[data-rw-qty="' + actKey.qty + '"]');
            }
            if (!back) { back = fresh.querySelector('.rw-cartpage__h1'); }
            if (back) { try { back.focus({ preventScroll: true }); } catch (e) {} }
          }
        }
        else if (renderVersion === cartPageRenderVersion) { location.reload(); }
      })
      .catch(function () { if (renderVersion === cartPageRenderVersion && mutationVersion === CartDrawer.mutationVersion) location.reload(); });
  }
  function initCartQty() {
    if (!document.getElementById('rw-cart-form')) return;
    var up0 = document.querySelector('.rw-cartpage__update'); if (up0) up0.hidden = true; /* W10-1b Mobile-tip 6: no-JS-fallback (1×1px) uit de tabvolgorde zodra JS actief is */
    var undoTimer = null, undoEl = null;
    var status = cartPageStatus, rerender = cartPageRerender;
    function setBusy(row, on) {
      if (!row) return;
      row.classList.toggle('is-busy', !!on);
      row.setAttribute('aria-busy', on ? 'true' : 'false');
    }
    function rowError(row, msg) {
      if (!row) return;
      var err = row.querySelector('.rw-cartrow__err');
      if (!msg) { if (err) err.remove(); return; }
      if (!err) { err = document.createElement('p'); err.className = 'rw-cartrow__err'; row.appendChild(err); }
      err.textContent = msg;
    }
    function change(line, qty, row, note) {
      if (row && row.classList.contains('is-busy')) return Promise.resolve(); // W6-3 r5: geen dubbele mutatie op dezelfde regel
      if (qty !== 0) hideUndo(); /* W10-1b A11y-gate B5: de blijvende undo-melding ruimt op bij de volgende wijziging */
      var removalUndo = qty === 0 ? undoEl : null;
      setBusy(row, true);
      rowError(row, null);
      var key = CartDrawer.itemKey(row);
      var version = key ? CartDrawer.beginChange() : CartDrawer.mutationVersion;
      var response = key ? CartDrawer.requestData(routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }) : Promise.reject(new Error('Ververs je winkelwagen en probeer het opnieuw.'));
      return response.then(function (cart) {
          if (!CartDrawer.isCart(cart)) throw new Error('Controleer je winkelwagen voordat je het opnieuw probeert.');
          if (version !== CartDrawer.mutationVersion) CartDrawer.concurrentChanges = true;
          if (CartDrawer.concurrentChanges) return;
          updateCartCount(cart.item_count);
          return bundleGuard(cart).then(function () { if (version !== CartDrawer.mutationVersion) CartDrawer.concurrentChanges = true; if (!CartDrawer.concurrentChanges) return rerender(); }).then(function () {
            if (version !== CartDrawer.mutationVersion) CartDrawer.concurrentChanges = true;
            if (CartDrawer.concurrentChanges) return;
            var msg = note || (qty === 0 ? 'Product verwijderd uit je winkelwagen.' : 'Aantal bijgewerkt naar ' + qty + '.');
            status(msg);
            if (qty !== 0) cartPageToast(msg.replace(/\.$/, '')); // bij 0 is de undo-toast al de bevestiging
          });
        })
        .catch(function (err) { if (removalUndo && undoEl === removalUndo) hideUndo(); if (key && (!(err && err.status) || err.status === 400)) CartDrawer.concurrentChanges = true; if (key && CartDrawer.concurrentChanges) CartDrawer.changeFailureMessage = (err && err.message) || 'Controleer je winkelwagen.'; setBusy(row, false); rowError(row, (err && err.message) || 'Controleer je winkelwagen en probeer het opnieuw.'); })
        .finally(function () { if (!CartDrawer.concurrentChanges || CartDrawer.pendingChanges <= 1) setBusy(row, false); return key ? CartDrawer.finishChange() : null; });
    }
    function hideUndo() {
      if (undoTimer) { clearTimeout(undoTimer); undoTimer = null; }
      if (undoEl) { undoEl.remove(); undoEl = null; }
    }
    function showUndo(snapshot) {
      hideUndo();
      undoEl = document.createElement('div');
      undoEl.className = 'rw-cart-undo rw-cart-undo--undo';
      undoEl.setAttribute('role', 'status');
      /* W10-1b A11y-gate B5 (WCAG 2.2.1): geen tijdslimiet op een melding met actie — blijft staan tot de volgende wijziging, met eigen sluitknop; in de DOM direct na de H1 zodat Tab hem meteen bereikt */
      undoEl.innerHTML = '<span>Verwijderd' + (snapshot.title ? ': ' + escHtml(snapshot.title) : '') + '</span><button type="button" class="rw-cart-undo__btn">Ongedaan maken</button><button type="button" class="rw-cart-undo__x" aria-label="Melding sluiten">&times;</button>';
      undoEl.querySelector('.rw-cart-undo__x').addEventListener('click', function () { hideUndo(); var h1x = document.querySelector('.rw-cartpage__h1'); if (h1x) { try { h1x.focus({ preventScroll: true }); } catch (e) {} } });
      undoEl.querySelector('.rw-cart-undo__btn').addEventListener('click', function () {
        hideUndo();
        /* W10-1b (IxD W6-5 r4): niet ~1,5 s op BODY wachten — focus meteen naar de paginakop, statusregel meldt de bezig-staat */
        status('Bezig met terugzetten\u2026'); var h1u = document.querySelector('.rw-cartpage__h1'); if (h1u) { try { h1u.focus({ preventScroll: true }); } catch (e) {} }
        var item = { id: snapshot.id, quantity: snapshot.qty };
        if (snapshot.props) item.properties = snapshot.props;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [item] })
        }).then(function (r) { if (!r.ok) throw new Error('add failed'); return rerender(); })
          .then(function () { status('Product teruggezet in je winkelwagen.'); cartPageToast('Teruggezet in je winkelwagen'); var h1 = document.querySelector('.rw-cartpage__h1'); if (h1) h1.focus({ preventScroll: true }); return fetch('/cart.js'); })
          .then(function (r) { return r.json(); }).then(function (c) { updateCartCount(c.item_count); })
          .catch(function () { status('Terugzetten is niet gelukt. Probeer het opnieuw.'); cartPageToast('Terugzetten is niet gelukt'); });
      });
      var h1p = document.querySelector('.rw-cartpage__h1'); if (h1p) h1p.insertAdjacentElement('afterend', undoEl); else document.body.appendChild(undoEl);
      if (h1p) { try { h1p.focus({ preventScroll: true }); } catch (e) {} } /* W10-1b IxD-gate B4: focus op de H1 — de undo-balk is de eerstvolgende Tab-stop */
      // W6-5 IxD r3: de verwijderknop is weg -> focus naar de paginakop (status meldt 'Verwijderd'; Ongedaan maken is de volgende Tab)
      if (document.activeElement === document.body) { var h1 = document.querySelector('.rw-cartpage__h1'); if (h1) { try { h1.focus({ preventScroll: true }); } catch (e) {} } }
    }
    function snapshotOf(row) {
      var props = null;
      try { props = row.getAttribute('data-rw-props') ? JSON.parse(row.getAttribute('data-rw-props')) : null; } catch (e) {}
      var nmEl = row.querySelector('.rw-cartrow__name'); var vrEl = row.querySelector('.rw-cartrow__variant');
      var snapTitle = (nmEl ? nmEl.textContent.trim() : '') + (vrEl && vrEl.textContent.trim() ? ' · ' + vrEl.textContent.trim() : ''); /* W10-1b E-com-gate B2: conditie identificeert de regel bij gemengde condities */
      return { id: parseInt(row.getAttribute('data-rw-variant'), 10), qty: parseInt(row.getAttribute('data-rw-qty-now'), 10) || 1, props: props, title: snapTitle };
    }
    function clamp(input) {
      var box = input.closest('.rw-cartrow__qty');
      var qmax = parseInt((box && box.getAttribute('data-rw-qty-max')) || '0', 10);
      var v = parseInt(input.value, 10);
      if (isNaN(v) || v < 0) v = 0;
      input.dataset.rwClampNote = '';
      if (qmax > 0 && v > qmax) {
        v = qmax;
        input.dataset.rwClampNote = qmax === 1 ? 'Er is maar 1 exemplaar beschikbaar; aantal op 1 gezet.' : 'Er zijn maar ' + qmax + ' exemplaren beschikbaar; aantal op ' + qmax + ' gezet.';
      }
      input.value = v;
      return v;
    }

    document.addEventListener('click', function (e) {
      var form = e.target.closest('#rw-cart-form');
      if (!form) return;
      var row = e.target.closest('.rw-cartrow');
      var btn = e.target.closest('[data-rw-qty]');
      if (btn && row) {
        e.preventDefault();
        var input = row.querySelector('[data-rw-qty-input]');
        if (!input) return;
        var v = parseInt(input.value, 10) || 0;
        v = btn.getAttribute('data-rw-qty') === 'inc' ? v + 1 : Math.max(0, v - 1);
        var qmax = parseInt((btn.closest('.rw-cartrow__qty') || row).getAttribute('data-rw-qty-max') || '0', 10);
        if (qmax > 0 && v > qmax) return;
        input.value = v;
        if (v === 0) showUndo(snapshotOf(row));
        change(row.getAttribute('data-rw-line'), v, row);
        return;
      }
      var rm = e.target.closest('.rw-cartrow__remove');
      if (rm && row) {
        e.preventDefault();
        showUndo(snapshotOf(row));
        change(row.getAttribute('data-rw-line'), 0, row);
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var input = e.target.closest('#rw-cart-form [data-rw-qty-input]');
      if (!input) return;
      e.preventDefault();
      // W6-3 r5: Enter alleen als 'bevestig' — blur laat het change-event het (enige) werk doen;
      // een eigen submit hier gaf twee POSTs (keydown + change) en bij '0' twee verwijderde regels.
      // W10-1c gate r3 (A11y B1): ongewijzigde waarde → niets doen (focus blijft); gewijzigd → focusdoel onthouden
      // zodat de her-render het aantal-veld van dezelfde regel terugvindt (2.4.3), net als de +/−-knoppen.
      var qrow = input.closest('.rw-cartrow');
      if (qrow && parseInt(input.value, 10) === parseInt(qrow.getAttribute('data-rw-qty-now'), 10)) return;
      cartRefocusHint = qrow ? { line: qrow.getAttribute('data-rw-line'), key: CartDrawer.itemKey(qrow), label: input.getAttribute('aria-label'), tag: 'INPUT', qty: null } : null;
      input.blur();
    });
    document.addEventListener('change', function (e) {
      var input = e.target.closest('#rw-cart-form [data-rw-qty-input]');
      if (!input) return;
      var row = input.closest('.rw-cartrow');
      var v = clamp(input);
      if (v === 0) showUndo(snapshotOf(row));
      change(row.getAttribute('data-rw-line'), v, row, input.dataset.rwClampNote);
    });
  }

  /* ----------------------------------------- favorieten (lokaal opgeslagen, geen header-teller) */
  var FAV_KEY = 'reway_favs';
  function favGet() { try { return JSON.parse(localStorage.getItem(FAV_KEY) || '{}'); } catch (e) { return {}; } }
  function favSet(o) { try { localStorage.setItem(FAV_KEY, JSON.stringify(o)); } catch (e) {} }
  function favSnap(b) {
    return {
      handle: b.getAttribute('data-rw-wish'),
      title: b.getAttribute('data-fav-title') || '',
      url: b.getAttribute('data-fav-url') || '',
      img: b.getAttribute('data-fav-img') || '',
      price: b.getAttribute('data-fav-price') || '',
      vendor: b.getAttribute('data-fav-vendor') || '',
      cond: b.getAttribute('data-fav-cond') || ''
    };
  }
  function favMark() {
    var favs = favGet();
    $$('[data-rw-wish]').forEach(function (b) { var on = !!favs[b.getAttribute('data-rw-wish')]; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); }); /* W7-2 gate r5 (A11y B1) */
    /* W7-2 gate r5 (E-com B3): header-ingang naar /pages/favorieten zodra er iets bewaard is */
    var favN = Object.keys(favs).length;
    /* W10-1c gate r3 (A11y tip 5): de favorieten-knop is altijd zichtbaar (CSS toonde hem al bij 0) — geen hidden-attribuut dat de DOM tegenspreekt */
    $$('[data-rw-fav-count]').forEach(function (c) { c.textContent = favN > 99 ? '99+' : favN; c.hidden = !(favN > 0); }); /* W15-2c r3 (Friction B3): de badge blijft een getal */ /* W10-3 CD-tip 8: geen permanente '0'-badge */
  }
  function initFavorites() {
    favMark();
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-rw-wish]');
      if (!b) return;
      e.preventDefault(); e.stopPropagation();
      var h = b.getAttribute('data-rw-wish'); if (!h) return;
      var favs = favGet();
      if (favs[h]) { delete favs[h]; } else { favs[h] = favSnap(b); }
      favSet(favs);
      var favOn = !!favs[h];
      $$('[data-rw-wish="' + h + '"]').forEach(function (x) { x.classList.toggle('is-active', favOn); x.setAttribute('aria-pressed', favOn ? 'true' : 'false'); });
      /* W7-2 gate r5 (A11y B1): toggle is anders onwaarneembaar voor screenreaders */
      announce((favOn ? 'Bewaard als favoriet: ' : 'Verwijderd uit favorieten: ') + (b.getAttribute('data-fav-title') || ''));
      var favN2 = Object.keys(favs).length;
      $$('[data-rw-fav-count]').forEach(function (c) { c.textContent = favN2 > 99 ? '99+' : favN2; c.hidden = !(favN2 > 0); });
      if (typeof window.RewayFavRender === 'function') window.RewayFavRender();
    });
  }
  window.RewayFavGet = favGet;
  window.RewayFavMark = favMark;   // herbruik na live grid-updates (in-categorie zoeken)

  /* ------------------------------------------------------------- boot */
  document.addEventListener('DOMContentLoaded', function () {
    initMobileNav();
    CartDrawer.init();
    // De cart-drawer is op gewone pagina's verborgen: haal aanbevelingen pas op bij open().
    // Op de winkelwagenpagina staat hetzelfde blok direct in beeld en vullen we het wel meteen.
    var cartForm = document.getElementById('rw-cart-form');
    if (cartForm) upsellFill(cartForm);
    initAddForms();
    initPredictiveSearch();
    initQuickShop();
    initCartQty();
    initTrustPill();
    initFavorites();
    bundleGuard();       // bundel-integriteit checken bij elke paginalading
  });
  window.RewayCart = CartDrawer;
  window.RewayAddToCart = addToCart;   // bundels (rw-bundle) voegen meerdere items in één keer toe
})();

/* W1-3: productkaart-media krijgt pas een witte achtergrond zodra het beeld
   geladen is (getinte laad-state i.p.v. kale witte vlakken). Delegatie in de
   capture-fase omdat 'load' niet bubbelt; werkt ook voor later geinjecteerde
   kaarten (zoekresultaten, upsells). */
(function () {
  function mark(img) {
    var media = img.closest && img.closest('.rw-pcard__media');
    if (media) media.classList.add('is-loaded');
  }
  document.addEventListener('load', function (e) {
    if (e.target && e.target.tagName === 'IMG') mark(e.target);
  }, true);
  document.querySelectorAll('.rw-pcard__media img').forEach(function (img) {
    if (img.complete && img.naturalWidth > 0) mark(img);
  });
})();

/* W5-4 gate: de conditie-uitleg (ⓘ) staat binnen het variant-label — een klik/tap selecteerde
   stilzwijgend die variant (koop-het-verkeerde-product-risico). preventDefault blokkeert de
   label-activatie; focus toont de band. Escape verbergt de band ook in de hover-staat (WCAG 1.4.13). */
document.addEventListener('click', function (e) {
  var tip = e.target && e.target.closest ? e.target.closest('.rw-cvtip') : null;
  if (!tip) return;
  e.preventDefault();
  tip.classList.remove('is-off');
  tip.focus();
});
document.addEventListener('keydown', function (e) {
  if (e.key !== 'Escape') return;
  var focused = document.activeElement && document.activeElement.closest ? document.activeElement.closest('.rw-cvtip') : null;
  if (focused) {
    /* W10-1e (A11y-tip W8-2 r3): Escape sluit de uitleg maar de focus blijft op de ⓘ-trigger zelf
       (i.p.v. naar de radio te springen) — is-off onderdrukt de :focus-pop; blur ruimt de klasse op.
       In de uitverkochte-lijst is dit ook de juiste plek (de ⓘ blijft de trigger). */
    e.rwTipDismissed = true;
    focused.classList.add('is-off');
    focused.addEventListener('blur', function () { focused.classList.remove('is-off'); }, { once: true });
  }
  document.querySelectorAll('.rw-cvtip:hover:not(.is-off)').forEach(function (t) {
    e.rwTipDismissed = true;
    t.classList.add('is-off');
    t.addEventListener('mouseleave', function () { t.classList.remove('is-off'); }, { once: true });
  });
});

/* W8-1: terug-naar-boven op lange resultaatpagina's (collecties + /search) — gate W7-1 (Impatient):
   koop-collecties van 1.000+ producten hadden er geen (sell wel). Verschijnt na ~2,5 schermhoogtes,
   spiegelt sell .rw-totop; rechtsonder (trust-pill zit linksonder), reduced-motion = instant. */
(function () {
  if (!document.querySelector('[data-rw-results], .rw-search-page [data-rw-body]')) return;
  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'rw-totop';
  btn.setAttribute('aria-label', 'Naar boven');
  btn.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5"/><path d="m5 12 7-7 7 7"/></svg>';
  btn.addEventListener('click', function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduce ? 'instant' : 'smooth' });
    var h1 = document.querySelector('h1');
    if (h1) { h1.setAttribute('tabindex', '-1'); h1.focus({ preventScroll: true }); }
  });
  document.body.appendChild(btn);
  /* W8-1 gate (Mobile B3): alleen zichtbaar bij scroll-OMHOOG (terug-intent) — tijdens het omlaag
     browsen bedekte de knop kaart-CTA's rechtsonder; omlaag scrollen verbergt hem direct weer. */
  var on = false, ticking = false, lastY = window.scrollY;
  function check() {
    ticking = false;
    var y = window.scrollY;
    var up = y < lastY - 2, down = y > lastY + 2;
    lastY = y;
    var nearBottom = (y + window.innerHeight) >= (document.documentElement.scrollHeight - 480); /* W15-2c r7 (Visual B5): onderaan (paginering/footer) altijd bereikbaar, ook zonder scroll-omhoog */
    var want = y > window.innerHeight * 1.5 && (nearBottom || (on ? !down : up)); /* W10-1c (E-com r2 T-e/r3 T-6): drempel 2,5 → 1,5 scherm */
    if (want !== on) { on = want; btn.classList.toggle('is-on', on); }
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
})();


/* W10-1c (E-com r3 T-2 / A11y r2 t1): sorteren en filteren blijven een reload (contract A9) — maar de
   scrollpositie en (bij sorteren) de focus komen na de navigatie terug, zodat de koper niet op y=0 opnieuw begint. */
(function () {
  var KEY = 'rwSortRestore';
  function save(extra) {
    try { sessionStorage.setItem(KEY, JSON.stringify({ p: location.pathname, y: window.scrollY, t: Date.now(), f: extra || '' })); } catch (err) {}
  }
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('#rw-sort, [data-rw-search-sort], .rw-incat-toolbar__sort select')) save('sort'); /* W10-1c gate (E-com B1): de zichtbare collectie-select is een naamloze toolbar-kopie */
  }, true);
  document.addEventListener('submit', function (e) {
    if (e.target && e.target.id === 'rw-facets') save('');
  }, true);
  /* W15-2a (Impatient B3): de conditie-chips zijn tag-links (contract A9: volledige navigatie) — bewaar de scrollpositie voor de doelpagina,
     zodat de koper na de wissel Nieuw/Tweedehands/Alles op dezelfde hoogte in het grid terugkomt (zelfde herstel als sorteren/filteren). */
  document.addEventListener('click', function (e) {
    var chip = e.target.closest && e.target.closest('a.rw-condchip[href]');
    if (!chip) return;
    try { var u = new URL(chip.href, location.href); sessionStorage.setItem(KEY, JSON.stringify({ p: u.pathname, y: window.scrollY, t: Date.now(), f: 'cond' })); } catch (err) {}
  }, true);
  /* W15-2c r1 (Friction B3): pagineren is de vierde manier om de set te wijzigen en de enige die op y=0 landde (H1, chips en toolbar
     opnieuw langs) — bewaar voor de doelpagina de hoogte van het resultatengrid onder de gepinde header + toolbar, zodat pagina 2
     direct bij de eerste kaart begint (zelfde herstel-wachtlus als sorteren/filteren; focus gaat mee naar het grid). */
  document.addEventListener('click', function (e) {
    var pl = e.target.closest && e.target.closest('.rw-pagination a[href]');
    if (!pl || !/template-(collection|search)/.test(document.body.className)) return;
    var grid = document.querySelector('[data-rw-results]') || document.querySelector('[data-rw-body]');
    if (!grid) return;
    try {
      var cs = getComputedStyle(document.documentElement);
      var hh = parseFloat(cs.getPropertyValue('--rw-header-h')) || 0, th = parseFloat(cs.getPropertyValue('--rw-toolbar-h')) || 0;
      var y = Math.max(0, Math.round(grid.getBoundingClientRect().top + window.scrollY - hh - th - 12));
      var u = new URL(pl.href, location.href);
      sessionStorage.setItem(KEY, JSON.stringify({ p: u.pathname, y: y, t: Date.now(), f: 'page' }));
    } catch (err) {}
  }, true);
  /* W15-2a (Power B1): de browser herstelt de scrollpositie na 'terug' vanaf een PDP niet (de lijst rendert uitgesteld en is op dat moment te kort) —
     bewaar de positie bij het openen van een product vanuit een collectie/zoekpagina en zet hem na een back/forward-navigatie terug (zelfde wachtlus). */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="/products/"]');
    if (!a || !/template-(collection|search)/.test(document.body.className)) return;
    try { sessionStorage.setItem(KEY + ':back', JSON.stringify({ p: location.pathname + location.search, y: window.scrollY, t: Date.now() })); } catch (err) {}
  }, true);
  /* W15-2a gate (E-com B1): Chrome rendert een gehoverde link vooraf (prerender) — dat document leest de sessionStorage al VÓÓR de klik
     de positie wegschrijft en herstelde dus niets bij een muisklik op een conditie-chip (toetsenbord werkte). Bij activering krijgt het
     document de storage van de pagina die de klik deed; daarom pas dan herstellen. */
  function restore() { try {
    var st = JSON.parse(sessionStorage.getItem(KEY) || 'null');
    if (!st) {
      var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
      var back = JSON.parse(sessionStorage.getItem(KEY + ':back') || 'null');
      if (back && nav && nav.type === 'back_forward' && back.p === location.pathname + location.search && Date.now() - back.t < 30 * 60000) {
        st = { p: location.pathname, y: back.y, t: Date.now(), f: 'back' };
        sessionStorage.removeItem(KEY + ':back');
      }
    }
    if (st && st.p === location.pathname && Date.now() - st.t < 15000) {
      sessionStorage.removeItem(KEY);
      /* wachten tot de pagina hoog genoeg is (deferred parse → hoogte groeit nog) en dan pas zetten */
      var t0 = Date.now();
      (function tick() {
        var maxY = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
        if (maxY >= st.y || Date.now() - t0 > 3500) {
          window.scrollTo(0, Math.min(st.y, maxY));
          if (st.f === 'page') { var g = document.querySelector('[data-rw-results]') || document.querySelector('[data-rw-body]'); if (g) { if (!g.hasAttribute('tabindex')) g.setAttribute('tabindex', '-1'); try { g.focus({ preventScroll: true }); } catch (e3) {} } }
        }
        else { requestAnimationFrame(tick); }
      })();
      if (st.f === 'sort') { var focSort = function () { /* E-com r2 tip 1: de toolbar-kopie is op telefoon verborgen — het eerste ZICHTBARE sorteercontrol krijgt de focus */ var sels = document.querySelectorAll('.rw-incat-toolbar__sort select, #rw-sort, [data-rw-search-sort]'); for (var i = 0; i < sels.length; i++) { if (sels[i].getClientRects().length) { try { sels[i].focus({ preventScroll: true }); } catch (e2) {} return; } } }; focSort(); window.addEventListener('load', function () { setTimeout(focSort, 60); }, { once: true }); }
    }
  } catch (err) {} }
  if (document.prerendering) { document.addEventListener('prerenderingchange', restore, { once: true }); } else { restore(); }
})();

/* W8-1 gate (Buyer B1): Shopify's prijsfilter matcht op ALLE variantprijzen, ook uitverkochte.
   Een product met een goedkope uitverkochte conditie komt dus door "max 100" terwijl de leverbare
   conditie duurder is. Platform-gedrag (native params, contract A9) — we markeren die kaarten
   eerlijk i.p.v. te verzwijgen of te verbergen (paginering blijft intact). */
(function () {
  var host = document.querySelector('[data-rw-results], [data-rw-body]');
  if (!host) return;
  var sp = new URLSearchParams(location.search);
  var gte = parseFloat(sp.get('filter.v.price.gte')), lte = parseFloat(sp.get('filter.v.price.lte'));
  if (isNaN(gte) && isNaN(lte)) return;
  function annotate() {
    var n = 0;
    document.querySelectorAll('.rw-pcard[data-rw-amin]').forEach(function (c) {
      var amin = parseInt(c.getAttribute('data-rw-amin'), 10) || 0;
      var amax = parseInt(c.getAttribute('data-rw-amax'), 10) || 0;
      if (!amin) return;
      var boven = !isNaN(lte) && amin > Math.round(lte * 100);
      var onder = !isNaN(gte) && amax < Math.round(gte * 100);
      if (!boven && !onder) return;
      n++;
      if (!c.querySelector('.rw-pcard__offprice')) {
        var note = document.createElement('span');
        note.className = 'rw-pcard__only rw-pcard__offprice';
        note.textContent = boven ? 'Leverbare conditie boven je prijsfilter' : 'Leverbare conditie onder je prijsfilter';
        var pr = c.querySelector('.rw-pcard__price');
        if (pr) pr.insertAdjacentElement('afterend', note);
      }
    });
    var g = document.querySelector('.rw-coll__pricenote');
    if (n > 0) {
      if (!g) { g = document.createElement('p'); g.className = 'rw-coll__pricenote'; host.parentNode.insertBefore(g, host); }
      /* E-com-gate r2 B2: telling is per pagina — dat ook zo benoemen (geen resultaat-brede claim) */
      var txt = 'Op deze pagina: ' + n + (n === 1 ? ' product met' : ' producten met') + ' alleen nog een conditie buiten je prijsfilter (de passende conditie is uitverkocht).';
      if (g.textContent !== txt) g.textContent = txt;
    } else if (g) { g.remove(); }
  }
  annotate();
  new MutationObserver(function () { annotate(); }).observe(host, { childList: true, subtree: true });
})();

  /* W10-2b gate (Mobile B3): externe WebwinkelKeur-links in (beschermde) FAQ-/contentteksten volgen de linkconventie:
     nieuw venster + ↗ + sr-tekst — tekstinhoud blijft onaangeraakt (alleen presentatie/attributen). */
  document.addEventListener('DOMContentLoaded', function () {
    Array.prototype.forEach.call(document.querySelectorAll('a[href*="webwinkelkeur.nl"]'), function (a) {
      if (a.closest('[data-rw-wk-open]') || a.hasAttribute('data-rw-wk-open')) return;   // dialoog-triggers niet
      if (a.getAttribute('target') !== '_blank') { a.setAttribute('target', '_blank'); a.setAttribute('rel', 'noopener'); }
      if (!a.querySelector('.visually-hidden')) {
        var sr = document.createElement('span'); sr.className = 'visually-hidden'; sr.textContent = ' (opent in nieuw venster)';
        var gl = document.createElement('span'); gl.setAttribute('aria-hidden', 'true'); gl.textContent = ' ↗';
        a.appendChild(gl); a.appendChild(sr);
      }
    });
  });
